export default {
  platformName: "Smart Portal",
  user: "Usuário",
  users: "Usuários",
  password: "Senha",
  rememberMe: "Lembre de mim",
  futureAccess: "Salvar dados para acessos futuros",
  forgotPassword: "Esqueci a senha SOSDOCS",
  signin: "Acessar",
  enter: "Entrar",
  selectProcess: "Selecionar processo",
  process: "Processo",
  activities: "Atividades",
  name: "Nome",
  listName: "Nome da Lista",
  start: "Inicio:",
  end: "Fim:",
  portal: "Portal",
  external: "externo",
  systemName: "Smartdocs",
  lastname: "Sobrenome",
  certificateNotSelected: "Certificado não selecionado",
  expiredCertificate: "O certificado selecionado está expirado",
  repeatedStockingAreaName:
    "O nome da área da lotação informada já existe na nossa base de dados, favor verificar.",
  groupNotFound: "O grupo {x} não foi encontrado",
  accessProfileNotFound: "O perfil de acesso {x} não foi encontrado",
  stockingAreaNotFound: "A área de lotação {x} não foi encontrada",
  genericErr:
    "Houve um erro ao tentar executar a solicitação, por favor, verifique seus dados e conexão e tente novamente",
  errOCRRecognition: "Houve um erro ao tentar executar o reconhecimento",
  invalidCertificate: "O certificado selecionado é inválido",
  email: "E-mail",
  confirm: "Confirmar",
  homeSmart: "Home",
  signedSuccessMsg: "Documento(s) assinado(s) com sucesso",
  signedBy: "Assinado por {name}",
  "//ComboBox": "ComboBox",
  allProcess: "Todos os processos",
  "//SimpleLineChartok": "SimpleLineChartok",
  open: "Abertos",
  closed: "Fechados",
  generateNewVersion: "Gerar nova versão",
  templateGenerateNewVersionSuccess:
    "Versão de template gerada com sucesso. Para utilizar, você deve publicá-la",
  templateGenerateNewVersionFailure:
    "Não foi possível gerar a nova versão de template",
  templatePublishSuccess: "Template publicado com sucesso.",
  templatePublishFailure: "Não foi possível publicar o template",
  generate: "Gerar",
  confirmGenerateNewVersion:
    'Confirma a geração de uma nova versão do template "{templateName}"?',
  month: "Mês (Referência)",
  imageTreatment: "Tratamento de imagem",
  accountability:
    "Tratamos com clareza e transparência todas as regras e informações acordadas, prestando contas para todos os envolvidos.",
  insights:
    "Sempre gerar resultados mensuráveis para nossos clientes e para seus negócios, através de insights desenvolvidos por nossas automações.",
  benchmark:
    "Ser sempre a empresa lembrada por seus clientes quando o assunto é automação de processo e qualidade na entrega.",
  solution:
    "Estar sempre preparado para os desafios de negócios de nossos clientes, empoeirando-os de soluções sustentáveis.",
  id: "ID",
  "//group-member-list-page": "group-member-list-page",
  groupAddUser: "Usuário adicionado ao grupo com sucesso",
  groupRemoveUser: "Usuário excluído do grupo com sucesso",
  groupRegistration: "Cadastro de grupo",
  groupName: "Nome do Grupo",
  groupType: "Tipo do Grupo",
  groupID: "ID do Grupo",
  groupCreatedSucess: "Grupo criado com sucesso",
  groupMenu: "Grupos",
  createGroupMenu: "Criar novo grupo",
  listGroupMenu: "Lista de grupos",
  "//Group_update_page": "Página de atualização de grupo",
  editGroup: "Editar grupo",
  groupUpdateSucess: "Grupo atualizado com sucesso",
  "//Delete_group_model": "Model de exclusão de grupos",
  deleteGroup: "Excluir grupo",
  reallyDeleteGroup: "Você realmente deseja excluir o grupo",
  groupDelete: "Grupo deletado com sucesso",
  "//CriarProcessosok": "Criar Processosok",
  done: "Concluir",
  next: "Avançar",
  reset: "Reiniciar",
  delete: "Excluir",
  return: "Voltar",
  continue: "Continuar",
  action: "Ação",
  createProcess: "Criar processo",
  initializationActivity: "Atividade de inicialização",
  formInitializationActivity: "Formulário atividade de inicialização",
  activityReportCPF: "Atividade informar CPF",
  formActivityReportInform: "Formulário atividade informar CPF",
  activityProcessTermination: "Atividade de finalização de processo",
  publishProcessBPM: "Publicar o processo no BPM",
  accessingProcessCreated: "Acessando o processo criado",
  "//campoobrigatoriook": "campo-obrigatóriook",
  openForm: "Abrir formulário",
  settingRequiredField: "Configurando campo obrigatório",
  configuration: "Configuração",
  postingChangeBPM: "Publicando a alteração BPM",
  testingForm: "Testando formulário",
  "//learnListItemsok": "learnListItemsok",
  learnaboutBPMN: "Aprenda sobre BPMN",
  help: "Ajuda",
  lessonCreateProcess: "Lição: Criar processos",
  lessonRequiredField: "Lição: Campo obrigatório",
  "//mainListItemsok": "mainListItemsok",
  modelingProcesses: "Modelar processo",
  publishProcesses: "Publicar processo",
  startProcess: "Iniciar processo",
  myActivities: "Minhas tarefas",
  allActivity: "Todas tarefas",
  Activities: "Atividades",
  "//secondaryListItemsok": "secondaryListItemsok",
  administrative: "Administrativo",
  changePassword: "Trocar Senha",
  UserMenu: "Usuários",
  createUser: "Criar usuário",
  userList: "Lista de usuários",
  exit: "Sair",
  "//topMenuok": "topMenuok",
  myProfile: "Meu perfil",
  myAccount: "Minha conta",
  "//Camundadepolyok": "Camunda/depolyok",
  publishProcess: "Publicar processos",
  publishBPMNFormat: "Faça a publicação do seu processo no formato BPMN",
  "//Camundadepolyprocessok": "Camunda/depoly-processok",
  sucessPublish: "Processo publicado com sucesso",
  "//tasklistNOTOKAY ": "task-list NOT OKAY (CHANGE TASKLIST-PAGE)",
  tProcess: "Processo",
  activity: "Atividade",
  expirationDate: "Data de vencimento",
  creationDate: "Data de criação",
  notAllowed:
    "Usuário não tem permissão para as atividades. Contate o administrador do sistema.",
  noTask: "Parabéns, Você não tem atividades em aberto.",
  noTaskAll: "Parabéns, Você não tem atividades em aberto.",
  activitySucess: "Atividade concluída com sucesso",
  activityCancel: "Atividade cancelada com sucesso",
  "//tablejsok": "table.jsok",
  linesPerPage: "Linhas por página",
  "//Startprocesslistpageok": "Start-process-list-pageok",
  processToStart: "Iniciar processo",
  startNewProcess: "Iniciar novo processo",
  versionNumber: "Versão",
  allCategory: "Todas",
  category: "Categoria",
  categories: "Categorias",
  categoryProcess: "Processos",
  loadingProcessSettings: "Carregando as definições de processos",
  sucessCreateProcess: "Processo criado com sucesso",
  idInstance: "Id da instância do processo:",
  loadingForm: "Carregando formulário",
  loadingTask: "Carregando tarefa",
  "//PasswordChangeok": "PasswordChangeok",
  pchangePassword: "Troque sua senha",
  currentPassword: "Senha atual",
  newPassword: "Nova senha",
  confirmPassword: "Confirmar nova senha",
  btnChangePassword: "Trocar minha senha",
  sucessChangePass: "Senha atualizada com sucesso",
  sendEmailRestPass: "Enviar redefinição de senha",
  textResetPass: "Redefina sua senha",
  "//singUP": "singUP CHECK UPDATE-USER",
  firstName: "Primeiro nome",
  lastName: "Sobrenome",
  emailadress: "Endereço de e-mail",
  updateUser: "Atualizar",
  cancel: "Cancelar",
  passOne: "Senha",
  passTwo: "Confirmar senha",
  save: "Salvar",
  sCancel: "Cancelar",
  userCreatedSucess: "Usuário criado com sucesso",
  registerLotacaoArea: "Cadastrar área de lotação",
  lotacaoArea: "Área de lotação",
  stockingAreas: "Áreas de lotação",
  lotacaoAreaData: "Dados da área de lotação",
  accessProfile: "Perfil de acesso",
  editLotacaoAreaData: "Editar dados da área de lotação",
  viewLotacaoAreaData: "Visualizar dados da área de lotação",
  userRegistration: "Cadastrar usuário",
  userID: "ID do usuário",
  "//User-Profile_Pageok": "User-Profile_Pageok",
  userUpdatedSucess: "Usuário atualizado com sucesso",
  "// PUBLICPROCESSES": "PUBLIC PROCESSES",
  successfullyIssuedProcess: "Processo emitido com sucesso",
  publishYourCaseInTheFormatBpmn: "Publique seu processo no formato BPMN",
  "//PasswordForgetok": "PasswordForgetok",
  emailResetPassword:
    "Insira o seu email e enviaremos um link para você voltar a acessar a sua conta",
  processInstanceTableId: "ID",
  processInstanceTableNome: "Processo",
  processInstanceTableInicio: "Data de início",
  processInstanceTableFim: "Data de término",
  processInstanceTableStatus: "Status",
  "//row.js": "row.js",
  viewHistory: "Ver histórico (fluxo vivo)",
  editProfile: "Editar perfil",
  editGroups: "Editar grupos",
  deleteUser: "Excluir usuário",
  editUser: "Editar usuário",
  "//user-delete-modal": "user-delete-modal",
  userDel: "Excluir usuário",
  cancelDelete: "Cancelar",
  reallyDelete: "Você realmente deseja excluir o usuário",
  userDelete: "Usuário deletado com sucesso",
  "//document-validation": "document-validation",
  couldNotQuery: "Não foi possível fazer a consulta",
  find: "Buscar",
  documentValidation: "Pesquisar documentos",
  documents: "Documentos",
  documentCode: "Código do documento",
  searchProcess: "Pesquisar processo",
  search: "Pesquisar",
  variableFieldsHere: "Campos variáveis aqui",
  chooseActivity: "Escolha uma atividade",
  startDate: "Data de início",
  endDate: "Data de finalização",
  responsible: "Responsável",
  duration: "Duração",
  processHistory: "Histórico do processo",
  startedBy: "Iniciado por",
  startedAt: "Processo iniciado em",
  endedAt: "Processo finalizado em",
  diagram: "Diagrama",
  details: "Detalhes",
  timeline: "Linha do tempo",
  "//document-viewer": "document-viewer",
  documentType: "Tipo de documento",
  technicalAdvice: "Parecer",
  "//legendas": "Legenda do BPMDiagram",
  hasIncident: "Incidente",
  isExpired: "Expirado",
  variables: "Variáveis",
  variable: "Variável",
  metadata: "Metadados",
  value: "Valor",
  type: "Tipo",
  finished: "Finalizado",
  normal: "Normal",
  autoFinish: "Finalizado automáticamente",
  "//Modeler": "Menus Modeler",
  processNoname: "O processo não possui um nome",
  idProccesInvalid: "Altere o id padrão do processo",
  userTaskKeyIsInvalid:
    "A atividade ${activityIdOrName} não possui chave de formulário ou formulário vazio",
  taskKeyDuplicate:
    "A atividade ${activityIdOrName} possui chave de formulário duplicada",
  xmlFail: "Falha ao importar o XML",
  published: "Publicado",
  pulishSucess: "Processo publicado com sucesso",
  listProcesstitle: "Processos publicados",
  inputPlaceholder: "Selecione um processo",
  createButton: "Criar novo diagrama BPMN",
  openLocalButton: "Abrir arquivo local",
  openServerButton: "Abrir arquivo do servidor",
  undoButton: "Desfazer",
  redoButton: "Refazer",
  resetButton: "Redefinir para o nível de zoom padrão",
  zoomInButton: "Aumentar o zoom",
  zoomOutButton: "Diminuir o zoom",
  fullScreenButton: "Alternar para o modo tela cheia",
  deployButton: "Implantar o diagrama atual",
  downloadBpm: "Download diagrama BPMN",
  downloadSvg: "Download como imagem SVG",
  downloadYourTheme: "Faça o download do seu tema",
  searchProcesses: "Pesquisar processos",
  InternalServerError:
    "Ocorreu um erro, tente novamente ou contate o administrador",
  portalName: "Atividades",
  ruleList: "Listar",
  deleteRule: "Excluir",
  buttonNewRule: "Nova regra",
  buttonNewProject: "Criar novo",
  fonteDadoMenu: "Serviços",
  createfonteDadoMenu: "Novo",
  products: "Produtos",
  listFonteDadoMenu: "Listar serviços",
  createRuleMenu: "Novo",
  listRuleMenu: "Listar",
  RuleMenu: "Regras",
  nodeDivergenciaColecao: "Nó de divergência (coleção)",
  ruleCategory: "Categoria",
  ruleName: "Nome",
  nodeDivergencia: "Nó de divergência (elemento)",
  colecaoExecucaoRegra: "Coleção execução regra",
  noIdColecao: "Nó coleção",
  buttonRuleHistoric: "Histórico execução",
  buttonListRule: "Listar regras",
  matchPassword: "Essas senhas não coincidem. Tente novamente",
  "//BreadCrumbs Navegation": "Rotas dos breadcrumbs",
  rules: "Regras",
  create: "Criar",
  edit: "Editar",
  test: "Testar",
  interface: "Interface",
  clone: "Clonar",
  sentences: "Sentenças",
  startprocess: "Iniciar processo",
  tasklist: "Minhas tarefas",
  projects: "Projetos",
  alltasklist: "Todas tarefas",
  "all-tasklist": "Todas tarefas",
  task: "Tarefa",
  signup: "Cadastrar usuário",
  "user-list": "Lista de usuários",
  "pw-change": "Alterar senha",
  groups: "Grupos",
  group: "Grupo",
  "group-list": "Lista de grupos",
  remove: "Excluir",
  home: "Home",
  connect: "Associar",
  mapfields: "Mapear campos",
  historic: "Histórico",
  modelerprocess: "Modelar processos",
  deployprocess: "Publicar processos",
  enterDocumentHash: "Informe o hash do documento",
  documentHash: "Hash do documento",
  validate: "Validar",
  documentValidationComponentTitle:
    "Validar veracidade do documento e integridade da assinatura",
  documentValidationDescription: "Consultar a veracidade e autenticidade",
  "document-validation-singular": "Validar documento",
  "document-validation": "Validar documentos",
  "process-instance": "Pesquisar processos",
  deleteProjectMessage: "Você realmente deseja excluir o projeto",
  deleteProjectTitle: "Excluir projeto",
  accessPermissions: "Permissões de acesso",
  documentalSecureLevel: "Nível de guarda documental",
  logs: "Logs",
  logId: "ID",
  module: "Módulo",
  operation: "Operação",
  ipAdress: "Endereço de IP",
  logDescription: "Descrição",
  capturaDpi: "Resolução (DPI)",
  capturaBtnCaptura: "Capturar",
  capturaBtnSave: "Salvar documento(s)",
  capturaBtnClose: "Fechar",
  capturaDispositivos: "Dispositivos",
  capturaSemDocumentos: "Não há documentos digitalizados.",
  capturaConcluido: "Concluído com sucesso",
  capturaConclusaoFail: "Não foi possível concluir a transação",
  capturaSettingsPB: "Preto e branco",
  capturaSettingsTC: "Tons de cinza",
  capturaSettingsEC: "Em cores",
  capturaSettingsAA: "Auto alimentação",
  capturaSettingsSU: "ShowUI",
  selectClear: "Selecionar...",
  exportCSV: "Exportar para CSV",
  exportXLS: "Exportar para XLSX",
  exportPDF: "Exportar para PDF",
  export: "Exportar",
  imageColor: "Cor da imagem",
  associatedocument: "Associar documento",
  scanProfile: "Perfil de digitalização",
  scanProfileCreate: "Novo perfil de digitalização",
  scanProfileList: "Digitalizações",
  scanner: "Scanner",
  scanDocument: "Digitalizar documento",
  scanning: "Digitalizar",
  documentName: "Nome",
  documentData: "Data criação",
  documentAssociate: "foi associado à sua lista de documentos",
  multipleDocumentAssociate: "Documentos associados à sua lista de documentos",
  clickorDropDocument: "Clique ou Arraste um documento aqui",
  draftSavedSuccess: "Rascunho salvo com sucesso",
  themeSaveSuccess: "Tema salvo com sucesso",
  themeSaveError: "Erro ao salvar o tema",
  themeSelecionarArquivo: "Selecione um arquivo",
  themeSelectLogo: "Selecionar Logo",
  themeSelectBackground: "Selecionar background do login",
  signatureTaskRequiredMessage: "Favor assinar a tarefa",
  signatureRequiredMessage: "Favor assinar o documento",
  allowOtherSignatures:
    "Permitir a inclusão de outras assinaturas após assinado",
  dontAllowOtherSignatures: "Não permitir nenhuma assinatura após assinado",
  onlyPdfCurrentlyAllowed: "Apenas arquivos PDF podem ser assinados no momento",
  sign: "Assinar",
  selectSignatureType:
    "Selecione o tipo da assinatura que irá assinar o documento",
  electronicSignature: "Assinatura eletrônica",
  signDocumentWithLoginPassword: "Assinar documento com login e senha",
  digitalCertificate: "Certificado digital",
  signatureType: "Tipo de assinatura",
  protectionLevel: "Nível de proteção",
  signDocumentWithDigitalCertificate:
    "Assinar documento com certificado digital",
  digitalSignature: "Assinatura digital",
  defaultSignature: "Assinatura padrão",
  signatureWithTimeStamp: "Assinatura com carimbo do tempo",
  signDocument: "Assinar documento",
  signWithDigitalCertificate: "Assinar com certificado digital",
  selectaDigitalCertificateToAdvance:
    "Selecione um certificado digital para avançar",
  categoria: "Categoria",
  descricao: "Descrição",
  nome: "Nome",
  objetoEntrada: "Objeto de entrada",
  campoComparacao: "Campo de comparacao",
  idOperador: "Id operador",
  dataCriacao: "Data de criação",
  transacao: "Transação",
  regra: "Regra",
  modalDeployTitle: "Publicar processo",
  modalDeployMessage: "Deseja realmente publicar o processo",
  modalConfirmReplaceTitle: "Substituir componente",
  modalConfirmReplaceItemMessage:
    "Já existe um componente no grid! Deseja substituí-lo?",
  inputDataSource: "EntradaFonteDados",
  deleteSuccess: "Excluído com sucesso",
  deleteFailure: "Erro ao excluir",
  modalUserConfirmationTitle: "Atenção",
  modalUserConfirmationMessage:
    "Isso descartará as alterações realizadas no formulário atual. Ok",
  input: "Entrada",
  output: "Saída",
  new: "Novo",
  tableFirstPage: "Primeira página",
  tablePreviousPage: "Página anterior",
  tableNextPage: "Próxima página",
  tableLastPage: "Última página",
  tableAction: "Ações",
  tableUnvailableAction: "Ações indisponíveis",
  tableExport: "Exportar",
  tableExportCSV: "Exportar como CSV",
  tableSearch: "Procurar",
  tableEmpty: "Nenhum registro para exibir",
  tableRowsPerPage: "Linhas por página:",
  tableRows: "Linhas",
  signupPlatform: "Não possui uma conta? Cadastre-se",
  createAccount: "Crie sua conta",
  haveAccount: "Já tem uma conta? Entrar",
  approve: "Aprovar",
  newForm: "Novo formulário",
  centralRepository: "Repositório central",
  reports: "Relatórios",
  reportURL: "URL",
  reportDriver: "Driver",
  reportName: "Nome",
  reportUsername: "Usuário",
  reportPassword: "Senha",
  reportQuery: "Query SQL",
  reportNew: "Cadastrar relatório",
  reportUpdate: "Atualizar relatório",
  report: "Relatórios",
  updateList: "Atualizar lista",
  reportDeleteConfirmation: "Deseja excluir esse relatório",
  confirmDocumentDeleteTitle: "Excluir registro",
  reportDeleteTitle: "Excluir relatório",
  reportDeleteSuccess: "Relatório excluído com sucesso",
  reportDeleteError: "Erro ao excluir relatório",
  reportCreateSuccess: "Relatório cadastrado com sucesso",
  reportCreateError: "Erro ao cadastrar relatório",
  reportUpdateSuccess: "Relatório atualizado com sucesso",
  reportUpdateError: "Erro ao alterar relatório",
  reportConfigSaveSuccess: "Configurações salvas com sucesso",
  reportConfigSaveError: "Ocorreu um erro ao salvar as configurações",
  execute: "Execução",
  table: "Tabela",
  menuExport: "Métodos de exportação",
  "//SmartForm": "Traduções do SmartForm",
  smartforms: "SmartForms",
  formData: "Dados do Formulário",
  form: "Formulário",
  forms: "Formulários",
  toolTipId: "Nome de identificação do campo",
  propertieLabel: "Rótulo",
  detail: "Detalhar",
  toolTipLabel: "Rótulo deste campo",
  propertieDescription: "Descrição",
  toolTipDescription: "Descrição detalhada do campo",
  propertieToolTip: "Dica",
  toolTipToolTip: "Adiciona uma dica para este campo",
  propertieMultiline: "Múltiplas linhas",
  toolTipMultiline: "Define se o campo poderá ter multiplas linhas",
  propertieRows: "Número de linhas",
  propertieColor: "Cor",
  propertieRequired: "Obrigatório",
  maximumItemsInList: "Máximo de itens na lista",
  toolTipRequired:
    "Define que um campo de entrada deve ser preenchido antes de enviar o formulário. Apresenta uma mensagem definida quando não estiver preenchida",
  propertieReadonly: "Somente leitura",
  toolTipReadonly: "Define se o elemento estará ativo na interface do usuário",
  propertieFutureDate: "Permitir datas futuras",
  toolTipFutureDate:
    "Define se o calendário deixará ativa as datas futuras ou não.",
  propertieShowfield: "Mostrar campo na pesquisa",
  toolTipShowfield:
    "Define que este elemento estará visível na lista de tarefas",
  propertieHidden: "Oculto",
  toolTipHidden:
    "Um campo oculto ainda faz parte do formulário mas estará oculto",
  propertieFullWidth: "Ocupar linha inteira",
  toolTipFullWidth: "O campo irá ocupar todo o espaço referente a linha",
  propertieDisabled: "Inativo",
  propertieHelperText: "Texto de ajuda",
  propertieOnBlurApi: "API OnBlur",
  toolTipOnBlurapi:
    "Define que esse elemento irá receber informações personalizadas de uma API da web. Deve fornecer um caminho de URL",
  propertieRegex: "Expressão regular",
  toolTipRegex:
    "Define uma validação de REGEX que será aplicada antes de enviar o formulário",
  propertieRegexMessage: "Mensagem da expressão regular",
  toolTipRegexMessage:
    "Define uma mensagem a ser apresentada caso a expressão regular retorne um erro",
  propertieUpperCase: "Letras maiúsculas",
  toolTipUpperCase: "Exibe os dados em letras maiúsculas",
  propertieCSS: "Classe CSS customizada",
  toolTipCSS: "Classe CSS customizada para este compomente",
  propertieThousandSeparator: "Separador de milhar",
  toolTipThousandSeparator: "Adicione separador de milhar ao número",
  propertieDecimalSeparator: "Separador decimal",
  toolTipDecimalSeparator: "Suporte para número decimal",
  propertieDecimalScale: "Escala decimal",
  toolTipDecimalScale: "Define qual o limite de escala decimal",
  propertieAllowNegative: "Permite negativo",
  toolTipAllowNegative: "Permite números negativos",
  propertiePrefix: "Prefixo",
  toolTipPrefix: "Prefixo para o campo numérico",
  propertieMaxLength: "Tamanho máximo",
  toolTipMaxLength: " Define um tamanho máximo para o campo",
  propertieMinLength: "Tamanho mínimo",
  toolTipMinLegth: "Define um tamanho mínimo para o campo",
  propertieColumns: "Número de colunas",
  toolTipColumns: "Quantidade de colunas da Grid",
  toolTipRows: "Quantidade de linhas da Grid",
  toolTipHtml: "Permite criar ou editar seu proprio HTML",
  toolTipScript: "Permite criar ou editar seu proprio Javascript",
  proportion: "Proporção",
  width: "Largura",
  height: "Altura",
  labelSize: "Tamanho da legenda",
  externalUrl: "External URL",
  label: "Legenda",
  switchSize: "Checkbox pequeno",
  switchSizeTooltip: "Essa propriedade diminui o tamanho do interruptor",
  propertieDefaultValue: "Valor padrão",
  toolTipDefaultValue: "Define um valor padrão para ser exibido no campo",
  propertieImageViewer: "Visualizar imagem",
  toolTipImageViewer: "Habilita a visualização das imagens na tela",
  propertieUrlApiDocumentType: "URL da API para os (Tipos de documentos)",
  toolTipUrlApiDocumentType:
    "Define uma URL da APi da web que retorna os tipos de documentos que serão listados na interface do usuário",
  propertieReadOnlyDocumentType: "Somente Leitura (Tipos de documentos)",
  toolTipReadOnlyDocumentType:
    "Define que a lista de tipos de documentos estará ativada na interface do usuário",
  propertieUrlApiTechnicalAdvice: "URL da API para o (Parecer técnico)",
  toolTipUrlApiTechnicalAdvice:
    "Define um URL da API da web que retorna o parecer técnico que será listado na interface do usuário",
  propertieReadOnlyTechnicalAdvice: "Somente Leitura (Parecer técnico)",
  tooltipReadOnlyTechnicalAdvice:
    "Define que a lista de pareceres técnicos está ativada na interface do usuário",
  propertieSignatureRequired: "Assinatura do documento obrigatória",
  toolTipSignatureRequired:
    "Define que um arquivo PDF deve ser assinado antes de enviar o formulário. Mostrar uma mensagem definida quando não estiver preenchida",
  propertieSignatureTaskRequired: "Assinatura da tarefa obrigatória",
  toolTipSignatureTaskRequired:
    "Define que uma tarefa deve ser assinada antes de enviar o formulário. Mostrar uma mensagem definida quando não estiver preenchida.",
  addUser: "Adicionar usuário",
  datasourceType: "Tipo de fonte de dados",
  values: "Valores",
  api: "Api",
  addNew: "Adicionar novo",
  add: "Adicionar",
  itemkey: "Chave",
  properties: "Propriedades",
  styles: "Estilos",
  toolTipAssociatedocument: "Permitir a associação de documentos já utilizados",
  propertieDigitalize: "Digitalizar",
  propertieDigitalizeSmartdocs: "Digitalizar (Smartdocs)",
  toolTipDigitalize: "Permitir a digitalização de documentos",
  modalTaskLotconfirmQuestionMessage:
    "Você realmente deseja aprovar ${TasksLot} itens em lote?",
  modalTaskLotconfirmMessage: "Aprovação concluída com sucesso",
  modalTaskLotAproveTask: "Aprovação em lote",
  dueDateModalTitle: "Data de acompanhamento",
  minutas: "Minutas",
  dueDateModalContent: "Defina um período.",
  dueDateSelectType: "Selecione o tipo de acompanhamento",
  dueDateYears: "Ano(s)",
  dueDateMonth: "Mês(es)",
  dueDateWeeks: "Semanas",
  dueDateDays: "Dias",
  dueDateHour: "Hora(s)",
  dueDateMin: "Minuto(s)",
  dueDateSec: "Segundo(s)",
  backgroundColor: "Cor de fundo",
  textColor: "Cor de texto",
  sideMenu: "Menu lateral",
  topMenu: "Menu superior",
  menusColors: "Cores dos menus de navegação",
  backColors: "Cores de fundos",
  primaryColor: "Cor primária",
  secondaryColor: "Cor secundária",
  successFeedback: "Mensagens de sucesso",
  errorFeedback: "Mensagens de erro",
  background: "Fundo",
  onFocus: "Em foco",
  timerCycle: "Repitições",
  timerDateContent: "Defina a data inicial",
  propertieRequiredTechnicalAdvice: "Obrigatório (Parecer técnico)",
  propertieMessageRequiredTechnicalAdvice:
    "Mensagem obrigatória (Parecer técnico)",
  propertieRequiredDocumentType: "Obrigatório (Tipos de documentos)",
  propertieMessageRequiredDocumentType:
    "Mensagem obrigatória (Tipos de documentos)",
  toolTipPropertieRequiredTechnicalAdvice: "Obrigatório (Parecer técnico)",
  toolTipPropertieMessageRequiredTechnicalAdvice:
    "Mensagem obrigatória (Parecer técnico)",
  toolTipPropertieRequiredDocumentType: "Obrigatório (Tipos de documentos)",
  toolTipPropertieMessageRequiredDocumentType:
    "Mensagem obrigatória (Tipos de documentos)",
  toolTipShareDocument: "Documentos anexados podem ser compartilhados",
  selectProcessContent: "Selecione o processo desejado",
  typography: "Tipografia",
  image: "Imagem",
  textfield: "Texto",
  numberfield: "Numérico",
  passwordfield: "Senha",
  datefield: "Data",
  cnpjfield: "CNPJ",
  cpffield: "CPF",
  button: "Botão",
  ecmDocuments: "Documentos ECM",
  checkbox: "Checkbox",
  checkboxList: "Lista de checkbox",
  select: "Lista de opções",
  linkedlist: "Lista encadeada",
  htmlelement: "HTML",
  grid: "Grid",
  stepper: "Etapa",
  steps: "Etapas",
  addStep: "Adicionar etapa",
  step: "Etapa",
  moveUp: "Subir",
  moveDown: "Descer",
  removeStep: "Remover",
  texts: "Textos",
  layout: "Layout",
  noSeparator: "Sem separador",
  components: "Componentes",
  dragHere: "Arraste os componentes",
  onlyOneStepper: "Só é permitido um componente Etapa por formulário.",
  stepperDragAndDrop: "Solte componentes aqui para esta etapa",
  alignCenter: "Centro",
  alignRight: "Direita",
  alignLeft: "Esquerda",
  align: "Alinhamento",
  shareDocument: "Compartilhar com outras pessoas",
  share: "Compartilhar",
  viewDocument: "Visualizar documento",
  dynamicList: "Lista dinâmica",
  attachmentDownloadFile:
    "Não é possível visualizar o arquivo ${filename}, clique no icone para efetuar o download",
  attachmentClickHere: "Clique aqui",
  generateFormFields: "Copiar campos",
  ok: "OK",
  fields: "Campos",
  size: "Tamanho",
  acceptedfiles: "Arquivos permitidos",
  text: "Texto",
  minLength: "O campo deve ter mais ${length} caracteres",
  watermarked: "Com marca d'água",
  pdfFeatures: "Características do pdf",
  authorization: "Autorização",
  userPipeGroup: "Usuário | Grupo",
  permission: "Permissão",
  FormId: "Id do Formulário",
  resourceId: "Id do Recurso",
  processDefinition: "Definição de processo",
  authorizationSuccessfullyRegistered: "Autorização cadastrada com sucesso",
  authorizationUpdatedSuccessfully: "Autorização atualizada com sucesso",
  authorizationRemovedSuccessfully: "Autorização excluída com sucesso",
  apifield: "Campo API",
  smartField: "Campo Formulário",
  addNewOnblur: "Vincular novo campo",
  requirederror: "Campo obrigatório",
  requiredFieldError: "Campo {x} obrigatório",
  requiredFormError: "Formulário obrigatório",
  ntfy_subject: "Assunto",
  ntfy_type: "Tipo da notificação",
  ntfy_type_info: "Informação",
  ntfy_type_error: "Erro",
  ntfy_type_success: "Sucesso",
  ntfy_type_warning: "Aviso",
  ntfy_message: "Mensagem",
  ntfy_for: "Para",
  ntfy_send_notification: "Enviar notificação",
  ntfy_send: "Enviar",
  ntfy: "Notificações",
  ntfy_mark_as_read: "Marcar como lido",
  reallyDeleteAuthorization: "Você realmente deseja excluir a Autorização?",
  reallyDeleteForm: "Você realmente deseja excluir o Formulário?",
  sucessDeleteAuthorization: "Autorização excluída com sucesso",
  application: "Aplicação",
  decisionDefinition: "Definição de decisão",
  definitionOfDecisionRequirements: "Definição dos requisitos de decisão",
  filter: "Filter",
  filterX: "Filtro de {x}",
  implantation: "Implantação",
  processInstance: "Instância de processo",
  lot: "Lote",
  groupMember: "Membro do grupo",
  tenantMember: "Membro do inquilino",
  controlPanel: "Painel de controle",
  assignment: "Tarefa",
  tenant: "Tenant",
  URLcopy: "URL copiada",
  share_document_notification:
    "O usuário {username} compartilhou um documento com você",
  share_document_notification_link:
    "<a href={link}>Clique para visualizar o documento</a>",
  statusIcon: "Status",
  errorMessage: "Mensagem de erro",
  propertieTypeTechnicalAdvice: "Tipo de fonte dados (Parecer técnico)",
  propertieTypeDocumentType: "Tipo de fonte dados (Tipos de documentos)",
  member: "Membros",
  permissions: "Permissões",
  permissionReadOnly: "Ler",
  permissionEdit: "Editar",
  cloneReport: "Clonar relatório",
  cloneReportSuccess: "Relatório clonado com sucesso",
  cloneReportError: "Ocorreu um erro ao clonar o relatório",
  categoryReport: "Relatório",
  startReport: "Executar",
  categoryDeleteTitle: "Excluir Categoria",
  categoryDeleteSuccess: "Categoria excluída com sucesso",
  categoryDeleteError: "Erro ao excluir a categoria",
  categoryDeleteConfirmation: "Deseja excluir esta categoria",
  categoryUpdateSuccess: "Categoria atualizada com sucesso",
  categoryCreateSuccess: "Categoria criada com sucesso",
  categoryUpdateError: "Erro ao atualizar a categoria",
  categoryCreateError: "Erro ao criar a nova categoria",
  categoryUpdate: "Atualizar categoria",
  categoryNew: "Nova categoria",
  categoryName: "Nome",
  propertieTypePendingDocuments: "Tipo de fonte de dados(Kit documental)",
  toolTipUrlApiPendingDocuments:
    "Define uma URL da APi da web que retorna os tipos de documentos obrigatórios para o usuário",
  pendingDocumentRequired: "Obrigatório",
  propertieUrlApiPendingDocuments: "URL da API para o (Kit documental)",
  propertieDisableClearable: "O campo não pode ser limpo",
  disableClearable: "Não pode ser limpo",
  propertieMutiple:
    "O valor deve ser uma matriz e o menu suportará várias seleções",
  multiple: "Multiplas seleções",
  propertieDisableCloseTooltip:
    "O pop-up não será fechado quando um valor for selecionado",
  propertieDisableClose: "Manter a lista aberta",
  templates: "Templates",
  description: "Descrição",
  documentTitle: "Título do documento",
  update: "Data de atualização",
  documentVersion: "Versão do documento",
  list: "Listar",
  templateDeleteTitle: "Excluir Template",
  templateDeleteSuccess: "Template excluído com sucesso",
  templateDeleteError: "Erro ao excluir o Template",
  templateDeleteConfirmation: "Deseja excluir este Template?",
  templateUpdateSuccess: "Template atualizado com sucesso",
  templateCreateSuccess: "Template criado com sucesso",
  templateUpdateError: "Erro ao atualizar o Template",
  templateCreateError: "Erro ao criar o novo Template",
  templateUpdate: "Atualizar Template",
  templateNew: "Novo Template",
  template: "Template",
  autocomplete: "Autocompletar",
  homeDocuments: "Home",
  send_notificationError: "Ocorreu um erro ao enviar notificação",
  send_notificationSuccess: "Notificação enviada",
  dashboard: "Painel de controle",
  dashboard_pendingdocuments: "Pendências documentais",
  dashboard_pendingdocuments_details: "Detalhes pendências documentais",
  "pending-documents": "Pendências documentais",
  pendencies: "Pendências",
  hasPendencies: "Possui pendências",
  confirmationMessage: "Confirmação",
  defaultConfirmationMessage: "Deseja concluir a atividade?",
  allnotifications: "Todas notificações",
  both: "Ambos",
  welcomeToFourcicle: "Bem vindo a _fourcicle",
  signUpMessage: "Cadastre-se e tenha um ambiente totalmente seu",
  signUp_userRegistration: "Cadastro do usuário",
  signUp_terms: "Termo de consentimento",
  signUp_config: "Configuração",
  signUp_orgConfig: "Configuração da organização",
  signUp_orgName: "Nome da organização ou equipe",
  signUp_checkTerm:
    "Concordo com os termos e condições e com a política de privacidade",
  signUp_personalInfo: "Informações pessoais",
  singUp_fillForm: "Por favor, preencha este formulário para criar uma conta",
  signUp_contact: "Contato",
  confirmPassword2: "Confirme a senha",
  enterValidEmail: "Insira um email válido",
  signUp_serverError: "Erro no servidor tente novamente mais tarde",
  signUp_confirmEmailText:
    "Um email de confirmação foi enviado para o seu e-mail, acesse o link enviado para dar continuidade ao cadastro",
  signUp_accessYourPlataform: "Acessar plataforma",
  signUp_finishedRegistration: "Seu cadastro está concluído",
  inviteUsersText: "Insira o endereço de e-mail para convidar usuários",
  invite: "Convidar usuários",
  sendInvite: "Enviar convite",
  invitelistText: "Convites enviados",
  inviteSendSuccess: "Convite enviado com sucesso",
  inviteResendSuccess: "Convite reenviado",
  inviteResendErr: "Ocorreu um erro ao reenviar o convite",
  inviteResend: "Reenviar convite",
  inviteEditSuccess: "Convite alterado com sucesso",
  inviteEditErrr: "Ocorreu um erro ao alterar o convite",
  access: "Acessar",
  tenantsRegistered: "Organizações cadastradas",
  tenantSelectError: "Erro ao selecionar tenant",
  passwordResetText: "Preencha os campos para resetar sua senha",
  passowrdResetSuccess: "Senha alterada com sucesso",
  passwordSendSuccess: "Link para redefinição de senha enviada",
  organizations: "Organizações",
  changeOrganization: "Alterar organização",
  signUp_AcceptTerms: "Ao concluir o cadastro você concorda com nosso",
  signUp_ConsetForm: "termo de uso",
  default_groups: "Grupos padrões",
  underAge: "Menor de idade",
  ruleEngine: "Motor de regras",
  link: "Vincular",
  ruleFields: "Campos da regra",
  activityFields: "Campos da atividade",
  groupUsers: "Usuários do grupo",
  amount: "Quantidade",
  connectedusers: "Usuários conectados",
  maximum: "Máximo",
  maximumPermitted: "Máximo permitido",
  instance: "Instância",
  numberofConnections: "Quantidade de conexões",
  openInstances: "Instâncias abertas",
  completedInstances: "Instâncias concluídas",
  loginByUser: "Quantidade de login por usuário",
  loginSimuntane: "Quantidade de logins simultâneos",
  openActivity: "Tarefas abertas",
  completedAcitivity: "Tarefas concluídas",
  processInstancesOpenCount: "Processos abertos",
  processInstancesCompleteCount: "Processos finalizados",
  NoRecords: "Sem registros",
  modelerSmartRuleConfigTitle: "Configurações do SmartRules",
  modelerSmartRuleTabRules: "Propriedades",
  modelerSmartRuleTabInParameters: "Paramêtros de Entrada",
  modelerSmartRuleTabOutParameters: "Paramêtros de saida",
  modelerSmartRuleOutParametersTypeRule: "Tipo de Saída Regra",
  modelerSmartRuleOutParametersTypeActivity: "Tipo de Saída Atividade",
  modelerSmartRuleOutTypeNew: "Não mapeado",
  modelerSmartRuleOutRuleTypeField: "Campos das Regras",
  modelerSmartRuleOutActivityTypeField: "Campos de Atividades",
  noFieldCreated: "Nenhum campo gerado.",
  configurationMenu: "Menu",
  wrongPassword: "Usuário e/ou senha incorreto(s)",
  signatureProcessError: "Houve uma falha ao executar o processo de assinatura",
  configurationMainColors: "Cores principais",
  configurationFeedback: "Feedback",
  configurationIcons: "Ícones",
  smartrules: "smartRules",
  userOverView: "Visão geral do usuário",
  activitiesToExpire: "Tarefas a expirar",
  activitiesExpired: "Tarefas expiradas",
  activitiesCompleted: "Tarefas completadas",
  registrationDate: "Data de registro",
  tasksDone: "Tarefas finalizadas",
  finalizeSelection: "Finalizar Seleção",
  reportPort: "Porta",
  reportDatabase: "Base de Dados",
  reportQueryResult: "Resultado Query SQL",
  reportTest: "Validar Relatório",
  reportTestSucess: "Relatório Válido",
  reportTestError: "Relatório Inválido",
  primary: "Primária",
  secondary: "Secundária",
  isSuccessMessage: "Esta é uma mensagem de sucesso",
  isErrorMessage: "Esta é uma mensagem de erro",
  breadcrumbs_create: "Novo",
  breadcrumbs_edit: "Editar",
  breadcrumbs_remove: "Excluir",
  breadcrumbs_process: "Processos",
  "breadcrumbs_my-tasks": "Minhas tarefas",
  "breadcrumbs_all-tasks": "Todas tarefas",
  "breadcrumbs_start-process": "Iniciar processo",
  breadcrumbs_modeler: "Modeler",
  "breadcrumbs_process-history": "Histórico de processo",
  breadcrumbs_documents: "Documentos",
  "breadcrumbs_document-validation": "Validar documentos",
  breadcrumbs_administrative: "Administrativo",
  listLotacaoArea: "Listar área da lotação",
  breadcrumbs_groups: "Grupos",
  breadcrumbs_interface: "Interface",
  log: "Log",
  breadcrumbs_logs: "Logs",
  breadcrumbs_users: "Usuários",
  breadcrumbs_categories: "Categorias",
  breadcrumbs_authorizations: "Autorizações",
  breadcrumbs_reports: "Relatórios",
  breadcrumbs_execute: "Executar",
  breadcrumbs_clone: "Clonar",
  breadcrumbs_smartrules: "SmartRules",
  breadcrumbs_rules: "Regras",
  breadcrumbs_import: "Importar",
  breadcrumbs_export: "Exportar",
  breadcrumbs_sentences: "Sentenças",
  documentNotInformed: "Documento não informado",
  breadcrumbs_datasource: "Fonte de dados",
  breadcrumbs_connect: "Associar",
  breadcrumbs_mapfields: "Mapear campos",
  breadcrumbs_historic: "Histórico",
  breadcrumbs_tree: "Árvore",
  breadcrumbs_audit: "Auditoria",
  "breadcrumbs_select-project": "Selecionar projeto",
  breadcrumbs_projects: "Projetos",
  breadcrumbs_templates: "Templates",
  breadcrumbs_startProcess: "Iniciar processo",
  breadcrumbs_task: "Atividade",
  "breadcrumbs_search-document": "Pesquisar documentos",
  "breadcrumbs_search-process": "Pesquisar processos",
  breadcrumbs_notifications: "Notificações",
  breadcrumbs_dashboard: "Painel de controle",
  "breadcrumbs_pending-documents": "Pendências documentais",
  breadcrumbs_organizations: "Organizações",
  breadcrumbs_diagram: "Diagrama",
  breadcrumbs_test: "Testar",
  breadcrumbs_status: "Status da plataforma",
  breadcrumbs_details: "Detalhes",
  breadcrumbs_smartecm: "Smart Drive",
  breadcrumbs_history: "Histórico",
  breadcrumbs_metadata: "Metadados",
  "breadcrumbs_documents-type": "Tipos documentais",
  camundaModelerFormAddField: "Adicionar campo",
  camundaModelerFormRemoveField: "Remover campo",
  camundaModelerFormCopyField: "Copiar campo",
  camundaModelerAddForm: "Adicionar formulário",
  disableOrganization: "Desativar organização",
  enableOrganization: "Desativar organização",
  organizationHasDisable: "Organização desativada",
  organizationHasEnable: "Organização ativada",
  activated: "Ativado",
  disabled: "Desativado",
  disable: "Desativar",
  dashboardProcessedRules: "Regras processadas",
  dashboardProcessedSentences: "Sentenças processadas",
  dashboardAttachedDocuments: "Documentos anexados",
  dashboardStorage: "Espaço utilizado (GB)",
  roomName: "Sala",
  videoCall: "Video Chamada",
  copyFieldTo: "Copiar campos para",
  statusPlatform: "Status da plataforma",
  statusSubtitle:
    "Consulte esta página para obter detalhes sobre o status da plataforma",
  services: "Serviços",
  modelerListCategoriesMenu: "Lista de categorias",
  integrationApi: "API de integração",
  detailsProcess: "Detalhes do processo",
  startProcessError: "Erro ao iniciar o processo",
  activityError: "Erro ao concluir atividade",
  createProjectMenu: "Novo",
  listProjectMenu: "Listar",
  inputObjectJsonErr: "Objeto de entrada está mal formatado",
  searchSmartEcm: "Pesquisar no smartECM",
  documentDeletedSuccessfully: "Documento deletado com sucesso",
  documentDeleteTitle: "Excluir documento",
  documentDeletedmessage: "Deseja remover este documento?",
  documentRenameSuccess: "Documento renomeado com sucesso",
  rename: "Renomear",
  download: "Download",
  formsPreview: "Preview dos Formulários",
  preview: "Visualizar",
  closePreview: "Fechar visualização",
  uploadDocumentSuccess: "Documento importado com sucesso",
  view_list: "Visualização em lista",
  view_grid: "Visualização em grade",
  upload_file: "Fazer upload de arquivos",
  new_folder: "Nova pasta",
  file_tree: "Navegar por pastas",
  tenantCreateSuccess: "Tenant criado com sucesso",
  createdBy: "Criado por",
  tenantName: "Nome",
  tenantCreateTitle: "Cadastrar tenant",
  ChangeHistory: "Histórico de alterações",
  smartFormDataTable: "Tabela dinâmica",
  smartFormDataTableAddHeader: "Adicionar cabeçalho",
  smartFormDataTableChangeMe: "Altere-me",
  smartFormDataTableField: "Campo",
  smartFormDataTableRowsPerPage: "Linhas por página",
  smartFormDataTableToolTipRowsPerPage:
    "Quantidade de itens que serão mostrados em cada página",
  smartFormDataTableCreateItem: "Novo item",
  smartFormDataTableEditItem: "Editar item",
  smartFormDataTableDeleteItem: "Excluir item",
  smartFormDataTableDeleteItemMessage: "Deseja remover o item da tabela?",
  smartFormDataTableOperation: "Operação",
  smartFormDataTableOperationSum: "Soma",
  smartFormDataTableOperationAverage: "Média",
  rotateLeft: "Virar à esquerda",
  rotateRight: "Virar à direita",
  zoomIn: "Reduzir o zoom",
  zoomOut: "Aumentar o zoom",
  removeImage: "Remover imagem",
  removeAllImages: "Remover todas as imagens",
  newDocument: "Novo documento",
  file: "Arquivo",
  move: "Mover para",
  moveDocumentSuccess: "Documento foi movido com sucesso",
  folderCreatedSucess: "Pasta criada",
  empty: "Vazio",
  openFolder: "Abrir",
  advancedSearch: "Busca avançada",
  templateName: "Nome do template",
  itemName: "Nome do item",
  owner: "Proprietário",
  createdOn: "Criado em",
  openedIn: "Aberto em",
  allowedDocTypes: "Tipo(s) do(s) arquivo(s) permitido(s) ao salvar",
  documentTypeTitle: "Tipos documentais",
  documentTypeCreateTitle: "Criar novo tipo documental",
  documentTypeEditTitle: "Editar tipo documental",
  documentTypeCreated: "Tipo documental criado com sucesso",
  documentTypeCreateFailed: "Ocorreu um erro ao criar o tipo documental",
  documentTypeDeleted: "Tipo documental deletado com sucesso",
  documentTypeDeletedError: "Ocorreu um erro ao deletar o tipo documental",
  documentTypeDeleteText: "Deseja remover o tipo documental?",
  documentTypeDeleteTitle: "Remover tipo documental",
  documentTypeEditFailed: "Ocorreu um erro ao editar o tipo documental",
  documentTypeEdited: "Tipo documental atualizado",
  documentMetadataTitle: "Metadados",
  documentMetadataCreateTitle: "Criar novo metadado",
  documentMetadataEditTitle: "Editar metadado",
  documentMetadataCreateFailed: "Ocorreu um erro ao criar o metadado",
  documentMetadataCreated: "Metadado criado com sucesso",
  documentMetadataEdited: "Metadado atualizado",
  documentMetadataEditError: "Ocorreu um erro ao editar o metadado",
  documentMetadataDeleted: "Metadado deletado com sucesso",
  documentMetadataDeleteError: "Ocorreu um erro ao deletar o metadado",
  documentMetadataDeleteTitle: "Remover metadado",
  documentMetadataDeleteText: "Deseja remover o metadado?",
  documentMetadataAdd: "Metadado vinculado ao tipo documental",
  documentMetadataAddError: "Ocorreu um erro ao vincular o metadado",
  documentMetadataAddTitle: "Vincular metadado",
  documentMetadataRemoveLinkText:
    "Você deseja remover o vinculo com o metadado?",
  documentMetadataRemoveLinkTitle: "Desvincular metadado",
  documentMetadataRemoveLinkError:
    "Ocorreu um erro ao remover o vinculo com o metadado",
  documentMetadataRemoveLinkSuccess: "Metadado desvinculado com sucesso",
  unlink: "Desvincular",
  disableMetadata: "Desativar metadado",
  sameNameErrorUpload:
    "Já existe arquivo com o mesmo nome, tente renomear e fazer o upload novamente",
  documentHistory: "Histórico",
  documentLogEmpty: "Nenhuma atividade registrada",
  maxSizeUpload:
    "Tamanho máximo do arquivo (em megabyte) que o upload aceitará",
  fileLimitUpload: "Número máximo de arquivos que podem ser carregados",
  showPreviewUpload: "Mostra a visualização na área de upload",
  maxAllowedNumbersFiles:
    "Número máximo permitido de arquivos excedido. Apenas ${filesLimit} permitidos",
  metadata_date: "Data",
  metadata_optionList: "Lista de opções",
  metadata_checkboxList: "Lista de checkboxes",
  metadata_linkedList: "Lista encadeada",
  metadata_file: "Arquivo",
  metadata_text: "Texto",
  metadata_number: "Númerico",
  image_invalid_type:
    "Formato da imagem inválido. Formatos válidos são ${imageTypes}",
  image_invalid_size:
    "Tamanho da imagem inválido. Tamanho permitido ${imageSize}",
  image_invalid_dimension:
    "Dimensões inválidas. As dimensões mínimas da imagem são ${imageDimension}",
  show_hide_properties_panel: "Mostrar/Esconder painel de propriedades",
  show_properties_panel: "Mostrar propriedades",
  hide_properties_panel: "Esconder painel de propriedades",
  "//comments":
    "//A partir daqui adição vinda do projeto SOSDocz //platformName: Smart DocZ",
  ID: "ID",
  Email: "Email",
  Password: "Senha",
  ConfirmPassword: "Confirmação senha",
  Actions: "Ações",
  Name: "Nome",
  Users: "Usuários",
  User: "Usuário",
  Addnewuser: "Adicionar novo usuário",
  Cancel: "Cancelar",
  DeleteUser: "Excluir usuário",
  DeleteUserConfirmation: "Confirma a exclusão do usuário selecionado?",
  InactivateUserConfirmation: "Confirma a inativação do usuário selecionado?",
  InactivateUser: "Inativar usuário",
  NewUser: "Novo usuário",
  FirstName: "Primeiro Nome",
  LastName: "Sobrenome",
  PasswordDoNotMatch: "As senhas informadas são diferentes.",
  Save: "Salvar",
  Draft: "Rascunho",
  SaveDraft: "Salvar rascunho",
  UserCreated: "Usuário cadastrado",
  Success: "Sucesso",
  Error: "Erro",
  EditUser: "Editar usuário",
  UserEdited: "Usuário editado",
  UserDeleted: "Usuário deletado",
  InvalidEmail: "Email inválido",
  UserView: " Visualizar usuário",
  ContactDetails: "Dados de contato",
  BirthDate: "Data de nascimento",
  ContinueRegistering: "Continuar cadastrando",
  CellPhone: "Celular",
  InstitutionalPhone: "Telefone institucional",
  Identification: "Identificação",
  InsertOnlyNumbers: "Insira apenas os números.",
  IncompleteCPF: "O CPF possui 11 números.",
  IncompletePassword:
    "A senha deve conter letras e números e possuir 8 caracteres",
  IncompleteData: "Informe a data completa.",
  View: "Visualizar",
  Delete: "Excluir",
  Edit: "Editar",
  Active: "Ativo",
  Inactive: "Inativo",
  Situation: "Situação",
  Inactivate: "Inativar",
  RequestDeletion: "Solicitar exclusão",
  ReasonForDeletion: "Motivo da solicitação de exclusão",
  CancelRequest: "Cancelar solicitação",
  SubmitRequest: "Enviar solicitação",
  ApproveDeletion: "Aprovar exclusão",
  DisapproveDeletion: "Reprovar exclusão",
  ReturnToPendingIssues: "Retornar às pendências",
  KeepDocumentArchived: "Manter o documento arquivado",
  DoNotDeleteAndKeepDocument:
    "Não excluir e manter o documento {x} em sua pasta atual.",
  ReasonForTheDisapproval: "Motivo da reprovação",
  KeepTheDocument: "Manter o documento",
  BackToAnalysis: "Voltar à análise",
  DeleteDocumentToRecycleBin: "Excluir documento para a lixeira",
  MoveTheDocumentToTheTrash: "Mover para a Lixeira o documento {x}.",
  MoveToTrash: "Mover para a Lixeira",
  TheDocumentHasBeenDeleted: "O documento foi excluído.",
  DocumentHasBeenDeletedAndMovedToTheRecycleBin:
    "O documento {x} foi excluído e movido para a Lixeira.",
  GoToTheRecycleBin:
    "Acesse a Lixeira para restaurar o documento para a pasta de origem.",
  FindDeletedDocument: "Localizar documento excluído",
  CodeSubject: "Código | Assunto",
  DeletionDate: "Data de exclusão",
  Restore: "Restaurar",
  RestoreDocument: "Restaurar documento",
  RestoreDocumentFromTheRecycleBin:
    "Restaurar o documento {x} da lixeira para a pasta de origem.",
  ReasonForRestoration: "Motivo da restauração",
  ReturnToTrash: "Voltar à lixeira",
  RestoreTheDocument: "Restaurar o documento",
  TheDocumentHasBeenRestored: "O documento foi restaurado",
  DocumentHasBeenRestoredToTheRepository:
    "O documento {code} foi restaurado para a pasta {repository} > {folder}.",
  DisabledUser: "Usuário inativado",
  Yes: "Sim",
  No: "Não",
  FolderDeleted: "Pasta excluída com sucesso!",
  WorkspaceDeleted: "Workspace excluído com sucesso!",
  FolderModalDeleteText: "A pasta :folderName será excluída. ",
  WorkspaceDeleteText: "O Workspace :workspaceName será excluído. ",
  FolderModalDeleteTitle: "Excluir pasta",
  WorkspaceModalDeleteTitle: "Excluir workspace",
  NewFolder: "Nova pasta",
  NewWorkspace: "Novo workspace",
  Description: "Descrição",
  FolderTitle: "Título da pasta",
  WorkspaceTitle: "Título do workspace",
  RenameFolder: "Renomear pasta",
  Rename: "Renomear",
  RenameFolderSucess: "Pasta renomeada com sucesso!",
  RenameWorkspaceSuccess: "Workspace renomeado com sucesso!",
  AccessCredentials: "Credenciais de acesso",
  InstitutionalRegistration: "Matrícula institucional",
  InstitutionalEmail: "E-mail institucional",
  IDLogin: "Id login",
  CPF: "CPF",
  Create: "Criar",
  CreateFolderSuccess: "Pasta criada com sucesso!",
  CreateWorkspaceSuccess: "Workspace criado com sucesso!",
  createRepository: "Criar repositório",
  MainArchive: "Arquivo Principal",
  DisplayOrder: "Ordem de exibição",
  FileTitle: "Título do arquivo",
  Size: "Tamanho",
  FormEditing: "Edição de Formulário",
  FormCreation: "Criação de Formulário",
  Extension: "Extensão",
  Genre: "Gênero",
  WhenWasDocumentCreated: "Quando este documento foi criado?*",
  WhoIsDocumentAuthor: "Quem é o(a) autor(a) deste documento? *",
  DidAnyoneCollaborateInCreation: "Alguém mais colaborou na criação?*",
  WhatIsTheTitleOfThisDocument: "Qual é o título deste documento?*",
  ThisDocumentExistOnpaper:
    "Este documento existe em papel (ou outro suporte físico)?*",
  HasPersonalData: "Possui dados pessoais",
  HasSensitiveData: "Possui dados sensíveis?",
  ExistOnPaper: "Existe em papel",
  DigitalFiles: "Arquivos digitais",
  EditRecord: "Editar registro",
  ReviewInformation: "Revisar informações",
  CreationDate: "Data de criação",
  Author: "Autor(a)",
  Title: "Título",
  Collaborators: "Colaboradores",
  Today: "Hoje",
  Next: "Avançar",
  Back: "Voltar",
  Exist: "Existe",
  NotExist: "Não existe",
  Main: "Principal",
  Attachment: "Anexo",
  Folder: "Pasta",
  NewDocument: "Novo documento",
  WizardDigitalFiles: "1. Arquivos Digitais",
  WizardSource: "2. Origem",
  WizardIdentification: "3. Identificação",
  WizardAuthorship: "4. Autoria",
  WizardStorage: "5. Armazenamento",
  WizardAccess: "6. Acesso",
  WizardReview: "7. Resumo",
  Date: "Data",
  Myself: "Eu",
  Type: "Tipo",
  UniqueID: "ID único",
  WizardStorageHelperFolder:
    "A pasta é o local onde este documento ficará armazenado.",
  WizardStorageHelperLocal:
    "Observe os padrões e selecione o local mais adequado entre as pastas disponíveis.",
  WizardAuthorshipContribution:
    "Além do(a) autor(a), outras pessoas podem ter contribuído na produção ou edição deste documento.",
  WizardAuthorshipCollaborators:
    "Selecione os colaboradores entre os usuários cadastrados.",
  WizardAuthorshipDocumentAuthorExplain:
    "O(a) autor(a) é a pessoa responsável pela emissão do documento.",
  WizardAuthorshipDocumentAuthor: "Um documento possui apenas um(a) autor(a).",
  WizardAuthorshipDocumentSelectAuthor:
    "Caso você não seja o(a) autor(a), selecione entre os usuários cadastrados.",
  WizardTitleExplain:
    "O título deve ajudar a identificar a finalidade e o conteúdo do documento.",
  WizardTitlePatterns:
    "Padrões trazem consistência à informação e facilitam sua recuperação.",
  WizardTitleRemember:
    "Lembre-se: outras pessoas podem precisar deste documento! ",
  SelectFolder: "Selecione uma pasta*",
  WizardSourceInfo:
    "Esta informação identifica o suporte em que está registrado o documento principal.",
  WizardSourceHelper:
    "Marque “Existe” quando estiver em posse do documento em papel, CD, DVD, disco, filme ou outra mídia física. ",
  WizardImportDocument:
    "Um documento pode ter inúmeros arquivos digitais, mas apenas um arquivo principal. Os demais arquivos digitais são complementares.",
  WizardImportOrder:
    "Ao selecionar o arquivo principal, ele ocupará, automaticamente, a posição 1 da ordem de exibição.",
  WizardAccessPersonalData:
    "Dados pessoais: fornecem informações que permitem identificar uma pessoa de forma direta. Ex.: nome, RG, CPF, gênero, data e local de nascimento, telefone, endereço residencial, retrato, renda.",
  WizardAccessSensitiveData:
    "Dados sensíveis: fornecem informações sobre origem racial ou étnica, convicação religiosa, opinião política, filiação a sindicato ou organização religiosa,  filosófico, saúde ou vida sexual, dado genético ou biométrico.",
  Documentcreated: "O documento nº :id foi registrado com sucesso!",
  DocumentEdited: "Registro editado com sucesso!",
  ImportDocument: "Importar documento",
  ImportDocuments: "Importar documentos",
  DeleteDocument: "Excluir documento",
  ReturnToDocuments: "Retornar aos documentos",
  DeleteDocumentText: "O documento :foldername será excluído.",
  DeleteDocumentSuccess: "Registro excluído com sucesso!",
  DropzoneText: "Arraste e solte um arquivo aqui ou clique",
  TableFirstPage: "Primeira página",
  TablePreviousPage: "Página anterior",
  TableNextPage: "Próxima página",
  TableLastPage: "Última página",
  TableAction: "Ações",
  TableExport: "Exportar",
  TableExportCSV: "Exportar como CSV",
  TableSearch: "Procurar",
  TableEmpty: "Nenhum registro para exibir",
  TableRowsPerPage: "Linhas por página:",
  TableRows: "Linhas",
  New: "Novo",
  Document: "Documento",
  Documents: "Documentos",
  UnregisteredDocuments: "Documentos não registrados",
  video: "Vídeo",
  audio: "Áudio",
  EmptyDocumentDatasource: "Não foram encontrado documentos",
  EmptyQueryReturn: "Consulta não retornou nenhum registro",
  Operation_Create: "Criado",
  Operation_Edit: "Editado",
  Operation_Download: "Download",
  Operation_Visualize: "Visualizado",
  HaveSensitivyData: "Este documento possui dados sensíveis",
  HavePersonalData: "Este documento possui dados pessoais",
  ItemType: "Tipo do item",
  History: "Histórico",
  Details: "Detalhes",
  OrderBy: "Ordenar por",
  DocumentID: "Id do Documento",
  Open: "Abrir",
  ViewDetails: "Ver detalhes",
  Authorship: "Autoria",
  Source: "Origem",
  Support: "Suporte",
  Storage: "Armazenamento",
  Access: "Acesso",
  PhysicalDocument: "Físico",
  DigitalDocument: "Digital",
  Event: "Evento",
  DateHour: "Data e hora",
  InactivateMetadataTitle: "Inativar metadado",
  EnableMetadata: "Ativar Metadado",
  templateActivationSuccess: "Template ativado com sucesso",
  templateInactivationSuccess: "Template inativado com sucesso",
  templateChangeStatusError:
    "Houve um erro ao tentar alterar o status do template",
  ActivateTemplate: "Template ativado com sucesso",
  InactivateTemplate: "Template inativado com sucesso",
  InactivateMetadata: "Metadado inativado com sucesso",
  CreateMetadata: "Criar Metadado",
  CreatedMetadata: "Metadado cadastrado com sucesso",
  InativateMetadataText: "Deseja inativar o metadado?",
  ChooseBaseComponent: "Escolha um componente base",
  Select: "Selecionar",
  DeletedMetadata: "Metadado excluído com sucesso",
  DeleteMetadataText: "Deseja remover o metadado?",
  DeleteMetadataTitle: "Remover metadado",
  ActiveMetadataTitle: "Ativar metadado",
  ActiveMetadataText: "Deseja ativar o metadado?",
  ActiveMetadata: "Metadado ativo com sucesso",
  ActivedStockingArea: "Área de lotação foi ativada com sucesso",
  DeletedDataSuccess: "Dados excluídos com sucesso!",
  ActivedAccessProfile: "Perfil de acesso ativado com sucesso!",
  ActivedUserGroup: "Grupo de usuário ativado com sucesso!",
  InactivedUserGroup: "Grupo de usuário inativado com sucesso!",
  InactivedAccessProfile: "Perfil de acesso inativado com sucesso!",
  InactivedStockingArea: "Área de lotação foi inativada com sucesso",
  Activate: "Ativar",
  Component: "Componente",
  EditMetadata: "Editar metadado",
  EditMetadataSuccess: "Metadado atualizado",
  listFormMenu: "Lista de formulários",
  selectForm: "Selecionar formulário",
  Locate: "Localizar",
  Languages: "Idioma",
  Appearance: "Aparência",
  LogAudit: "Auditoria de logs",
  GeneralSettings: "Configurações gerais",
  SecurityAvailability: "Segurança e disponibilidade",
  Signature: "Assinatura",
  CertificationAuthority: "Autoridade certificadora",
  WorksflowsServices: "Workflows e serviços",
  Workflow: "Fluxo de trabalho",
  DataList: "Lista de dados",
  CreateNewList: "Criar nova lista",
  CreateNewListSuccess: "Nova lista criada com sucesso!",
  CreateNewListFailure: "Houve um erro ao criar a nova lista",
  ListTitle: "Título da lista",
  ReturnToLists: "Retornar às listas",
  ReturnToList: "Retornar à lista",
  ActivateList: "Ativar lista",
  ActivateListSuccess: "Lista ativada com sucesso.",
  ActivateListFailure: "Houve um erro ao ativar a lista",
  ActivateListText1: "A ativação exibirá a lista para uso daqui em diante.",
  ActivateListText2: "Deseja ativar a lista?",
  InactivateList: "Inativar lista",
  InactivateListSuccess: "Lista desativada com sucesso.",
  InactivateListFailure: "Houve um erro ao desativar a lista",
  InactivateListText1:
    "A desativação ocultará a lista para uso daqui em diante. Mas mas não quebrará as referências a ela em instâncias anteriores à desativação.",
  InactivateListText2: "Deseja desativar a lista?",
  CloneList: "Clonar lista",
  CloneListSuccess: "Lista clonada com sucesso.",
  CloneListFailure: "Houve um erro ao clonar a lista",
  CloneListText1:
    "Deseja criar uma nova lista com os mesmos dados e itens que esta?",
  DeleteList: "Excluir lista",
  DeleteListSuccess: "Lista excluída com sucesso.",
  DeleteListFailure: "Houve um erro ao excluir a lista",
  DeleteListText1:
    "A exclusão eliminará a lista mas quebrará as referências a ela em todas instâncias anteriores ou futuras à exclusão.",
  DeleteListText2: "Deseja excluir a lista?",
  EditList: "Editar lista",
  EditListSuccess: "Lista editada com sucesso.",
  EditListFailure: "Houve um erro ao editar a lista",
  IcludeNewItem: "Incluir novo item",
  IcludeNewItemSuccess: "Item incluído com sucesso.",
  IcludeNewItemFailure: "Houve um erro ao incluir o novo item",
  CreateNewItem: "Criar novo item",
  ReturnToItems: "Retornar aos itens",
  EnterADate: "Informe uma data",
  EnterAText: "Informe um texto",
  EnterACPF: "Informe um CPF",
  EnterACNPJ: "Informe um CNPJ",
  EnterANumber: "Informe um número",
  EnterAHyperlink: "Informe um hyperlink",
  EditItem: "Editar item",
  EditItemSuccess: "Item editado com sucesso.",
  EditItemFailure: "Houve um erro ao editar o item",
  SaveChanges: "Salvar alterações",
  EditListItem: "Editar item da lista",
  EditListItemText1:
    "A edição alterará os valores do item da lista mas quebrará as referências a ele em instâncias anteriores à edição.",
  EditListItemText2: "Confirma a edição do item?",
  BackToEdition: "Retornar à edição",
  DeleteItemFromList: "Excluir item da lista",
  DeleteItemFromListSuccess: "Item excluído com sucesso.",
  DeleteItemFromListFailure: "Houve um erro ao excluir o item",
  DeleteItemFromListText1:
    "A exclusão eliminará o item da lista mas não quebrará as referências a ele em instâncias anteriores à exclusão.",
  DeleteItemFromListText2: "Deseja excluir o item?",
  CloneItemFromList: "Clonar item da lista",
  CloneItemFromListSuccess: "Item clonado com sucesso.",
  CloneItemFromListFailure: "Houve um erro ao clonar o item",
  CloneItemFromListText1: "Deseja criar na lista um novo item igual a este?",
  CloneItem: "Clonar item",
  DesativarItemFromList: "Desativar item da lista",
  DesativarItemFromListSuccess: "Item desativado com sucesso.",
  DesativarItemFromListFailure: "Houve um erro ao desativar o item",
  DesativarItemFromListText1:
    "A desativação ocultará o item para uso em todas as listagens em que ele estiver daqui em diante. Mas mas não quebrará as referências a ele em instâncias anteriores à desativação.",
  DesativarItemFromListText2: "Deseja desativar o item?",
  DesativarItem: "Desativar item",
  EnableListItem: "Ativar item da lista",
  EnableListItemSuccess: "Item ativado com sucesso.",
  EnableListItemFailure: "Houve um erro ao ativar o item",
  EnableListItemText1:
    "A ativação exibirá o item para uso em todas as listagens em que ele estiver daqui em diante.",
  EnableListItemText2: "Deseja ativar o item?",
  EnableItem: "Ativar item",
  UniqueNameOfTheColumn: "Nome único da coluna",
  ColumnLabel: "Label da coluna",
  DataTypeAndValue: "Tipo de dado/ valor",
  EditItems: "Editar itens",
  ContentDescription: "Descrição do conteúdo",
  ListColumns: "Colunas da lista",
  Column: "Coluna {number}",
  Readers: "Leitoras",
  ServicePortal: "Portal de serviços",
  ScanServices: "Digitalização, captura e impressão",
  Scanners: "Scanners",
  Print: "Imprimir",
  Printers: "Impressoras",
  ArchivalManagement: "Gestão arquivística de documentos",
  Organograma: "Organograma",
  Supports: "Suportes",
  Formats: "Formatos",
  Species: "Espécies",
  ProcessesTypes: "Tipos de processos",
  ClassificationTemporality: "Classificação e temporalidade",
  ControlledVocabularies: "Vocabulários controlados",
  Tags: "Etiquetas",
  SecrecyInformation: "Sigilo da informação",
  DocumentTypes: "Tipos de documento",
  Posts: "Cargos",
  Functions: "Funções",
  AccessProfiles: "Perfis de acesso",
  AccessGroups: "Grupos de acesso",
  UsersAccesses: "Usuário e acessos",
  Bin: "Lixeira",
  FolderTree: "Árvore de pastas",
  RegistrationPayment: "Cadastro e pagamento",
  SosdocsClient: "Cliente sosdocs",
  Orgregistration: "Cadastro da organização",
  ManagePlansAccounts: "Gerenciar planos e contas",
  Recent: "Recentes",
  Favorites: "Favoritos",
  PhysicalFile: "Arquivo físico",
  MySmartDrive: "Meu Smart Drive",
  TaskList: "Lista de tarefa",
  Inbox: "Caixa de entrada",
  Myitens: "Meus itens",
  AllInboxes: "Todas as caixas de entrada",
  Publish: "Publicar",
  ActiveFormTitle: "Ativar formulário",
  ActivateFormSucces: "Formulário ativado",
  ActivateFormText: "Deseja ativar esse formulário?",
  InativeFormTitle: "Inativar formulário",
  InativateFormSuccess: "Formulário inativado",
  InativeFormText: "Deseja inativar esse formulário?",
  ImportFormDropzoneText: "Arraste e solte um formulário aqui ou clique",
  FormDeletedSuccess: "Formulário excluido com sucesso",
  FormImportSuccess: "Formulário importado com sucesso",
  DocumentTypesList: "Tipos de documentos",
  DocumentTypeDeactivateSuccess: "Tipo de documento inativado com sucesso",
  DocumentTypeActivateSuccess: "Tipo de documento ativado com sucesso",
  DocumentTypeEditSuccess: "Tipo de documento editado com sucesso",
  DocumentTypeDeleteSuccess: "Tipo de documento excluido com sucesso",
  DocumentTypeDeactivateError: "Ocorreu um erro ao inativar o tipo documental",
  DocumentTypeActivateError: "Ocorreu um erro ao ativar o tipo documental",
  DocumentTypeDeleteError: "Ocorreu um erro ao deletar o tipo documental",
  DocumentTypeEditError: "Ocorreu um erro ao editar o tipo documental",
  CreateNewComponent: "Criar novo componente",
  ChooseComponentBase: "Escolha um componente pré-existente ou crie um novo",
  SaveAsMetadata: "Salvar como metadado",
  ImportNewDocument: "Importar novo documento",
  SelectDocumentType: "Selecionar tipo documental",
  IssueDate: "Data de emissão",
  AuthorName: "Nome do autor",
  YouIssuedThisDocument: "Foi você quem emitiu este documento?",
  GiveThisDocumentATitle: "Dê um título para este documento",
  ThisDocumentHaveACopyInPaper:
    "Este arquivo é cópia de um documento em papel?",
  UploadDocument: "Carregar documento",
  Conclude: "Concluir",
  defaultSaveTaskMessage: "Deseja salvar a atividade?",
  successSaveTask: "Atividade salva com sucesso",
  errorSaveTask: "Erro ao salvar atividade",
  indexMetadataContent: "Metadados para indexação de conteúdo",
  documentsForRegister: "Documentos para registrar",
  documentStorageLocation: "Local de armazenamento do documento",
  specificFolder: "Pasta específica",
  selectFolderBasedData: "Escolher pasta com base nos dados",
  copy: "Cópia",
  copyTooltip:
    "Informa para o sistema se deve ser realizado uma cópia dos documentos selecionados",
  selectedFolder: "Pasta selecionada",
  noFolderSelected: "Nenhuma pasta foi selecionada",
  WhoIssuedThisDocument: "Foi você quem emitiu este documento?",
  selectDocumentType: "Selecionar tipo de documento",
  status: "Status",
  completeConfiguration: "Configuração completa",
  tooltipCompleteConfiguration:
    "Exige o preenchimento de todos os dados para a criação de documento",
  savingTask: "Salvando atividade. Aguarde...",
  concludingTask: "Concluindo atividade. Aguarde...",
  selectedAccessProfiles: "Perfis de acesso selecionados",
  listAccessProfiles: "Listar perfis de acesso",
  registerAccessProfile: "Cadastrar perfil de acesso",
  viewAccessProfile: "Visualizar dados do perfil de acesso",
  editAccessProfile: "Editar dados do perfil de acesso",
  listUserGroups: "Listar grupos de usuários",
  listGroups: "Listar grupos",
  registerGroup: "Cadastra grupo",
  viewGroup: "Visualizar dados do grupo",
  editGroupData: "Editar dados do grupo",
  deleteSelected: "Excluir Selecionado",
  ScanningActivateModalTitle: "Ativar perfil de escaneamento",
  ScanningActivateModalContent: "Deseja realmente ativar esse perfil?",
  ScanningCloneModalTitle: "Clonar perfil de escaneamento",
  ScanningCloneTextPlaceholder: "Digite o nome do perfil de escaneamento",
  ScanningInactivateModalTitle: "Inativar perfil de escaneamento",
  ScanningInactivateModalContent: "Deseja realmente inativar esse perfil?",
  ScanningDeleteModalTitle: "Excluir perfil de escaneamento",
  ScanningDeleteModalContent: "Deseja realmente excluir esse perfil?",
  DataRegisteredSuccessfully: "Dados cadastrados com sucesso!",
  DataUpdatedSuccessfully: "Dados alterados com sucesso!",
  ScanProfile: "Perfil de digitalização",
  MaximumSizeWhenSave: "Tamanho máximo permitido ao salvar",
  MaximumSizeFileHelpText:
    "Tamanho máximo da imagem (em megabyte) que aceitará ao salvar MB",
  Profile: "Perfil",
  ImageRotation: "Rotação automática",
  ImageColor: "Cor da imagem",
  ResolutionDPI: "Resolução (DPI)",
  ScanningProfileActivated: "Perfil ativado com sucesso",
  ScanningProfileDisable: "Perfil desativado com sucesso",
  profileData: "Dados do perfil",
  ScanningProfileDeleted: "Perfil excluido com sucesso",
  ScanningProfileCloned: "Perfil clonado com sucesso",
  MandatoryDocumentSigning: "Assinatura do documento obrigatória",
  MandatoryTaskSignature: "Assinatura da tarefa obrigatória",
  SignatureType: "Tipo assinatura",
  Subscriber: "Assinante",
  SignatureMadeAt: "Assinatura realizada na(o)",
  SignatureDateTime: "Data/hora assinatura",
  Signatures: "Assinaturas",
  back: "Voltar",
  signatureDocumentNotFound:
    "Não foi possível localizar o documento com o código de verificação:",
  loadingDocument: "Carregando documento. Aguarde...",
  Hash: "Hash",
  TaskSignatureAgreement: "Concordo com a assinatura da tarefa",
  CorvertingFileError: "There was an error converting the file.",
  documentoUpload: "Documento upload",
  signOnTask: "Assinar na tarefa",
  minuta: "Minuta",
  ListOccupation: "Listar função",
  ActivateOccupation: "Ativar função",
  DisableOccupation: "Desativar função",
  ToggleEnableOccupationText:
    "Deseja realmente :type  os dados da função :name?",
  ListOccupationInternalError: "Ocorreu um erro interno ao buscar as funções",
  DisableOccupationInternalError:
    "Ocorreu um erro interno ao desativar a função",
  ActivateOccupationInternalError: "Ocorreu um erro interno ao ativar a função",
  ActivateOccupationSuccessfully: "Função ativada com sucesso!",
  DisableOccupationSuccessfully: "Função desabilitada com sucesso!",
  CreateBy: "Criado por",
  OccupationData: "Dados da função",
  DeleteData: "Excluir dados",
  DeleteOccupationText:
    "Deseja realmente excluir definitivamente os dados da função :name?",
  CreateOccupationInternalError:
    "Ocorreu um erro interno no cadastro da função",
  CreateOccupation: "Cadastrar função",
  EditOccupation: "Editar função",
  UpdateOccupationInternalError:
    "Ocorreu um erro interno ao atualizar as informações da função",
  GetOccupationInternalError:
    "Ocorreu um erro interno ao buscar as informações da função",
  ViewData: "Visualizar dados",
  EditJob: "Editar cargo",
  DeleteJobText:
    "Deseja realmente excluir definitivamente os dados do cargo :name?",
  GetJobInternalError:
    "Ocorreu um erro interno ao buscar as informações do cargo",
  UpdateJobInternalError:
    "Ocorreu um erro interno ao atualizar as informações da função",
  ActivateJob: "Ativar cargo",
  DisableJob: "Desativar cargo",
  ToggleEnableJobText: "Deseja realmente :type o cargo :name?",
  ListJobInternalError:
    "Ocorreu um erro interno ao buscar as informações do cargo",
  DisableJobInternalError: "Ocorreu um erro interno ao desativar o cargo",
  ActivateJobInternalError: "Ocorreu um erro interno ao ativar o cargo",
  ActivateJobSuccessfully: "Cargo ativado com sucesso!",
  DisableJobSuccessfully: "Cargo desabilitada com sucesso!",
  Printing: "Impressão",
  RequiredFieldErrorFeedback: "Campo :fieldname é obrigatório",
  RequiredSelectFieldErrorFeedback:
    "A seleção do campo :fieldname é obrigatório",
  PasswordsDoNotMatch: "As senhas não conferem",
  EnterAValidEmail: "Informe um email válido",
  PasswordMinLengthError: "A senha deve ter pelo menos 6 caracteres",
  CPFInformedIsNotValid: "CPF informado não é valido",
  Occupation: "Função",
  StockingArea: "Área lotação",
  Job: "Cargo",
  PasswordConfirmation: "Confirmação de senha",
  InstitutionalEnrollment: "Matrícula institucional",
  UserFullNameRequired: "Digite seu nome completo*",
  PersonalData: "Dados pessoais",
  InstitutionalBond: "Vínculo institucional",
  DeleteUserText:
    "Deseja realmente excluir definitivamente os dados do usuário?",
  CreateUserInternalError: "Ocorreu um erro interno no cadastro do usuário",
  GetAccessProfileInternalError:
    "Ocorreu um erro interno ao buscar as informações dos perfis de acesso",
  GetStockingAreaInternalError:
    "Ocorreu um erro interno ao buscar as informações das áreas de lotação",
  GetUserInternalError:
    "Ocorreu um erro interno ao buscar as informações de usuários",
  EditUserInternalError: "Ocorreu um erro interno ao editar usuário",
  DeleteUserInternalError: "Ocorreu um erro interno ao deletar o usuário",
  ActivateUserInternalError: "Ocorreu um erro interno ao ativar usuário",
  DisableUserInternalError: "Ocorreu um erro interno ao desativar usuário",
  ActivateUser: "Ativar usuário",
  DisableUser: "Desativar usuário",
  ToggleEnableUserText: "Deseja realmente :mode os dados do usuário :username?",
  ListUsers: "Listar usuários",
  Action: "Ação",
  GetUserLogInternalError:
    "Ocorreu um erro interno ao buscar os log do usuário",
  ActivateUserSuccessfully: "Usuário ativado com sucesso!",
  DisableUserSuccessfully: "Usuário desativado com sucesso!",
  UserGroups: "Grupos de usuários",
  ManageApprovalRequests: "Gerenciar solicitações de aprovação",
  ManageApprovalRequest: "Gerenciar solicitação de aprovação",
  XDocumentDetails: "Detalhes do documento {x}",
  RequestData: "Dados da solicitação",
  Requester: "Solicitante",
  ReasonForTheRequest: "Motivo da solicitação",
  Registration: "Matrícula",
  RequestedOn: "Solicitado em",
  RequestedOnX: "Solicitado em {x}",
  Deny: "Negar",
  EnterReasonForRefusal: "Informe o motivo da recusa",
  YearXMonthY: "Ano {x} e mês de {y}",
  DocumentSituation: "Situação do documento",
  ExclusionSituation: "Situação da exclusão",
  ConfirmPermanentDocumentsDeletion:
    "Deseja realmente solicitar exclusão definitiva do documento?",
  ReasonDocumentDeletion: "Por qual motivo deseja excluir este documento?",
  RequestSent: "A solicitação foi enviada.",
  AuthorizationUserAnalyzeProceedAccordingly:
    "Um(a) usuário(a) autorizado(a) vai analisar e proceder conforme a análise.",
  ContactYourAdministrator:
    "Procure o administrador do sistema se for preciso restaurar.",
  documentDeleteTitleX: "Excluir documento {x}",
  Aware: "Ciente",
  DeleteRequestSentForApproval:
    "Solicitação de exclusão enviada para aprovação",
  ModulesAndFeatures: "Módulos e funcionalidades",
  groupData: "Dados do grupo",
  SelectAll: "Selecionar todos",
  AccessProfileError: "Selecione pelo menos um perfil de acesso",
  myDocuments: "Meus documentos",
  dashboard_processpendingdocuments: "Pendências no processo",
  reallyDeleteDocument: "Você realmente deseja excluir o documento?",
  RefusalRegisteredSuccessfully: "Recusa registrada com sucesso",
  MyExclusionRequests: "Minhas solicitações de exclusão",
  searchFilter: "Filtro de busca",
  Approved: "Aprovadas",
  Disapproved: "Reprovadas",
  WaitingApproval: "Aguardando aprovação",
  monthAndYear: "Mês e ano",
  deliberate: "Deliberar",
  approverData: "Dados do aprovador",
  reasonForRefusal: "Motivo da recusa",
  Clean: "Limpar",
  RequestingUser: "Usuário solicitante",
  Functionality: "Funcionalidade",
  ToggleEnableGroupText: "Deseja realmente :type o grupo :name?",
  DisableGroupInternalError: "Ocorreu um erro interno ao desativar o grupo",
  ActivateGroupInternalError: "Ocorreu um erro interno ao ativar o grupo",
  ActivateGrop: "Ativar grupo",
  DisableGrop: "Desativar grupo",
  ActivateGroupSuccessfully: "Grupo ativado com sucesso!",
  DisableGroupSuccessfully: "Grupo desabilitado com sucesso!",
  MyRequests: "Minhas solicitações",
  All: "Todos",
  ListPendingApprovalDocuments: "Listar documentos pendentes de aprovação",
  PendingDocumentations: "Pendências documentais",
  FindDocumentWithPending: "Localizar documento com pendência",
  Analyze: "Analisar",
  ToggleEnableStockingAreaText:
    "Deseja realmente :type a área de lotação :name?",
  DisableStockingAreaInternalError:
    "Ocorreu um erro interno ao desativar a área de lotação",
  ActivateStockingAreaInternalError:
    "Ocorreu um erro interno ao ativar a área de lotação",
  ActivateStockingArea: "Ativar área de lotação",
  DisableStockingArea: "Desativar área de lotação",
  ActivateStockingAreaSuccessfully: "Área de lotação ativada com sucesso!",
  ChangeLog: "Log de alterações",
  DisableStockingAreaSuccessfully: "Área de lotação desabilitada com sucesso!",
  Deliberated: "Deliberado",
  ToggleEnableAccessProfileText:
    "Deseja realmente :type o perfil de acesso :name?",
  DisableAccessProfileInternalError:
    "Ocorreu um erro interno ao desativar o perfil de acesso",
  ActivateAccessProfileInternalError:
    "Ocorreu um erro interno ao ativar o perfil de acesso",
  ActivateAccessProfile: "Ativar perfil de acesso",
  DisableAccessProfile: "Desativar perfil de acesso",
  ActivateAccessProfileSuccessfully: "Perfil de acesso ativado com sucesso!",
  DisableAccessProfileSuccessfully:
    "Perfil de acesso desabilitado com sucesso!",
  ListJobs: "Listar cargos",
  CreateJob: "Criar cargo",
  UniversityDegreesProcesses: "Processos de diplomas",
  Course: "Curso",
  Institution: "Instituição",
  ProcessStartDate: "Data início do processo",
  InvalidateDegree: "Invalidar diploma",
  ToggleEnableDegreeProcessText:
    "Deseja realmente :type o processo de diploma :name?",
  DisableDegreeProcessInternalError:
    "Ocorreu um erro interno ao desativar o processo de diploma",
  ActivateDegreeProcessInternalError:
    "Ocorreu um erro interno ao ativar o processo de diploma",
  ActivateDegreeProcess: "Ativar processo de diploma",
  DisableDegreeProcess: "Desativar processo de diploma",
  ActivateDegreeProcessSuccessfully: "Processo de diploma ativado com sucesso!",
  DisableDegreeProcessSuccessfully:
    "Processo de diploma desabilitado com sucesso!",
  StudentData: "Dados do aluno",
  StudentID: "ID do aluno",
  StudentIDError: "É preciso informar o ID do aluno",
  StudentName: "Nome do Aluno",
  StudentNameError: "É preciso informar o nome do aluno",
  StudentBirthDate: "Data de nascimento",
  StudentBirthDateError: "É preciso informar a data de nascimento do aluno",
  StudentNationality: "Nacionalidade",
  StudentNationalityError: "É preciso informar a nacionalidade do aluno",
  StudentNaturalness: "Naturalidade",
  StudentNaturalnessError: "É preciso informar a naturalidade do aluno",
  StudentUf: "UF",
  StudentUfError: "É preciso informar o distrito aluno",
  StudentCPF: "CPF do aluno",
  StudentCPFError: "É preciso informar o CPF do aluno",
  StudentRG: "Número do RG",
  StudentRGError: "É preciso informar o RG do aluno",
  StudentRGDate: "Data emissão RG",
  StudentRGDateError: "É preciso informar a data de emissão do RG",
  StudentRGEmiter: "Órgão emissor RG",
  StudentRGEmiterError: "É preciso informar o orgão emissor do RG",
  StudentGender: "Sexo",
  StudentGenderFemale: "Feminino",
  StudnetGenderMale: "Masculino",
  MaintenantData: "Dados Mantenedora",
  Student: "Aluno",
  RegistrationBook: "Livro de Registro",
  Expedition: "Expedição",
  Publication: "Publicação",
  Record: "Registro",
  Address: "Logradouro",
  Number: "Número",
  District: "Bairro",
  Complement: "Complemento",
  City: "Cidade",
  InvalidCep: "O cep informado não foi encontrado",
  MaintainerName: "Nome da mantenedora",
  CompanyName: "Razão social",
  AddressData: "Endereço",
  MecCode: "Código MEC",
  NameIESEmissora: "Nome da IES Emissora",
  IESEmissor: "IES Emissora",
  Accreditation: "Credenciamento",
  PublicationDate: "Data de publicação",
  PublicationSection: "Seção da publicação",
  PublicationPage: "Página da publicação",
  Reaccreditation: "Recredenciamento",
  NameIESRegistradora: "Nome da IES Registradora",
  courseData: "Dados do curso",
  courseName: "Nome do curso",
  courseNameError: "É preciso informar o nome do curso",
  courseCodeMEC: "Código do curso MEC",
  courseCodeMECError: "É preciso informar o codigo do curso",
  qualificationName: "Nome habilitação",
  qualificationNameError: "É preciso informar o nome da habilitação",
  titleConferred: "Título conferido",
  titleConferredError: "É preciso informar o titulo conferido",
  degreeConferred: "Grau conferido",
  degreeConferredError: "É preciso informar o grau conferido",
  authorizationDocNumber: "Nº do documento de autorização",
  authorizationDocNumberError:
    "É preciso informar o n° do documento de autorização",
  modality: "Modalidade",
  modalityError: "É preciso informar a modalidade",
  recognitionDocNumber: "Nº do documento de reconhecimento",
  recognitionDocNumberError:
    "É preciso informar o n° do documento de reconhecimento",
  graduationDate: "Data de colação de grau",
  graduationDateError: "É preciso informar a data de colação de grau",
  courseAddress: "Endereço da oferta do curso",
  campusUnit: "Campus/Unidade",
  campusUnitError: "É preciso informar o campus/unidade",
  reference: "Referência",
  referenceError: "É preciso informar a referência",
  publishDegreeNotFound: "O grupo {x} não foi encontrado",
  degreeSuccessfullyUpdated: "Processo de diploma editado com sucesso",
  degreeProcessNotFoundById: "Processo de diploma não encontrado com o id {x}",
  reallyInactivateDegree:
    "Você realmente deseja inativar o processo de diploma {x}",
  IssueDegree: "Emitir diploma",
  Degree: "Diploma",
  RequiredField: "Campo de preenchimento obrigatório",
  Consultstudent: "Consultar aluno",
  Consult: "Consultar",
  SearchFilters: "Filtros de pesquisa",
  HasSheetAndSequence: "Possui folha e sequência?",
  DegreeProcess: "Processo do diploma",
  RegistrationBookData: "Dados Livro de Registro",
  ResponsibleForRegistration: "Responsável pelo Registro",
  RegistrationNumberID: "ID do número da matrícula",
  From: "De",
  Until: "Até",
  UndeterminedTime: "Tempo indeterminado",
  issued: "Emitido",
  inProgress: "Em andamento",
  awaitingSignature: "Aguardando assinatura",
  transmittedForRegistration: "Transmitido para registro",
  documentPending: "Pendência documental",
  approved: "Aprovado",
  disapproved: "Reprovado",
  Invalidate: "Invalidar",
  DegreeProcessSuccessfullyInvalidated:
    "Processo de diploma invalidado com sucesso",
  SubstituteDocument: "Substituir documento",
  registered: "Registrado",
  Period: "Período",
  RGorCNHStudent: "RG ou CNH do Aluno",
  SignDocuments: "Assinar documentos",
  DegreeId: "Código do diploma",
  EmissionStartDate: "Data início emissão",
  SuccessfulRegister: "Cadastro realizado com sucesso!",
  Important: "Importante",
  RequiredSignature:
    "As assinaturas digitais são obrigatórias para emitir o Diploma Digital",
  WishSign: "Deseja seguir para assinatura dos documentos?",
  SignNow: "ASSINAR AGORA",
  SignLater: "ASSINAR DEPOIS",
  CorroborativeDocuments: "Documentos comprobatórios",
  SchoolHistory: "Histórico escolar do curso superior",
  VoterTitle: "Título de eleitor",
  DocumentIdentityOrCNH: "Documento de identidade civil ou CNH",
  BirthOrMarriageCertificate: "Certidão de nascimento ou casamento",
  SchoolCertificate: "Documento de conclusão do ensino médio",
  DocumentCPF: "Cadastro de pessoa física - CPF",
  IESResponsabilityTerm: "Termo de responsabilidade IES",
  GraduationExam: "Prova de colação de grau",
  CompletionAndInternship: "Conclusão e estágio curricular",
  DiplomaToBeRegisteredAndPublished: "Diploma a ser registrado e publicado",
  ResponsabilityTerm: "Termo de responsabilidade",
  InstructionResponsabilityTerm:
    "TERMO DE RESPONSABILIDADE PARA INSTRUÇÃO DO PROCESSO DE EXPEDIÇÃO DE DIPLOMA DIGITAL",
  AsignDocumentsAndDegree: "Assinar Documentos e Diploma",
  DegreeXML: "XML do diploma",
  SubscriberType: "Tipo de Assinante",
  IESEmisserAndRegister: "IES Emissora e Registradora",
  Secretary: "Secretário",
  Coordinator: "Coordenador",
  Director: "Diretor",
  TimelineSign: "Linha do tempo de assinaturas (Legenda)",
  Signed: "Assinado",
  Pending: "Pendente",
  CompleteRegistration: "Concluír cadastro",
  YouWillOnlyBeAbleToUploadFileWithPdfFormat:
    "Só será permitido upload de arquivo com formato em PDF",
  DateInclusion: "Data inclusão",
  Included: "Incluido",
  XMLSuccessfullySigned: "XML assinado com sucesso!",
  DegreeProcessSavedWithPendingDocuments:
    "Processo de diploma salvo com pendências documentais",
  CorroborativeDocumentsNotInformed: "Documentos comprobatórios não informados",
  SignerHasAlreadySigned:
    "É permitido assinar apenas uma vez cada documento comprobatório e XML do diploma",
  ClassName: "Nome da classe",
  Class: "Classe",
  Subgroup: "Subgrupo",
  ClassifiableQuestion: "Classificável?",
  ActiveForUseQuestion: "Ativo para uso?",
  ClassId: "Id. da classe",
  ClassCod: "Cód. da classe",
  ArchivalClassification: "Classificação arquivística",
  ListArchivalClassification: "Listar Classificação Arquivística",
  CreateArchivalClassification: "Cadastrar Classificação e Temporalidade",
  EditArchivalClassification: "Editar Classificação e Temporalidade",
  ClassData: "Dados da classe",
  ClassIdentifier: "Identificador de classe",
  ClassSubordination: "Subordinação da classe",
  CurrentPhase: "Fase corrente",
  NumberYearsCurrentPhase: "Quantidade de anos fase corrente",
  IntermediatePhase: "Fase intermediária",
  NumberYearsIntermediatePhase: "Quantidade de anos fase intermediária",
  FinalDestination: "Destinação final",
  Observation: "Observação",
  TaskName: "Nome da tarefa",
  StartDate: "Data início",
  EndDate: "Data fim",
  Observations: "Observações",
  SecrecyAssociatedClass: "Sigilo associado à classe",
  Code: "Código",
  DetailArchivalClassification: "Detalhar classificação e Temporalidade",
  Classification: "Classificação",
  Day: "Dia",
  DueDate: "Data do venc.",
  NoExpirationDate: "Sem data de vencimento",
  Late: "Atrasado",
  ExpirationSituation: "Situação venc.",
  DeleteArchivalClassificationInternalError:
    "Ocorreu um erro interno ao tentar deletar a classificação arquivística",
  DisableArchivalClassificationInternalError:
    "Ocorreu um erro interno ao tentar desativar a classificação arquivística",
  ActivateArchivalClassificationInternalError:
    "Ocorreu um erro interno ao tentar ativar a classificação arquivística",
  ActivateArchivalClassificationSuccessfully:
    "Classificação arquivística ativada com sucesso!",
  DisableArchivalClassificationSuccessfully:
    "Classificação arquivística desabilitada com sucesso!",
  DeleteArchivalClassificationSuccessfully:
    "Classificação arquivística deletada com sucesso!",
  ToggleEnableArchivalClassificationText:
    "Deseja realmente :type a classificação arquivística :name?",
  ReallyDeleteArchivalClassification:
    "Deseja realmente excluír a classificação arquivística :name?",
  ActivateArchivalClassification: "Ativar classificação arquivística",
  DisableArchivalClassification: "Desativar classificação arquivística",
  ExclusionFromArchivalClassification: "Exclusão de classificação arquivística",
  RequiredClass: "É necessário informar a classe",
  RequiredCode: "É necessário informar o código",
  RequiredSubject: "É necessário informar o assunto",
  OnlyIntegerNumbers: "Este campo deve conter apenas números inteiros",
  OnlyPositiveNumbers: "Este campo aceita apenas números positivos",
  ReclassificationReason: "Motivo reclassificação",
  ReasonRequerid: "O motivo é necessário.",
  NewDegree: "Novo diploma",
  Modules: "Módulos",
  ConsultBy: "Consultar por",
  ConsultDocuments: "Consultar documentos",
  CreationFrom: "Data de criação (De)",
  CreationTo: "Data de criação (Até)",
  Or: "Ou",
  SearchByContent: "Busca por conteúdo",
  EnterDesiredData: "Informe os dados desejados",
  ConsultProcess: "Consultar processo",
  Version: "Versão",
  DisableOCR: "Recurso do OCR desabilitado",
  Repository: "Repositório",
  ImportClassificationAndTemporalityTable:
    "Importar tabela classificação e temporalidade",
  DownloadExcelTemplate: "Baixar modelo excel",
  DownloadCSVTemplate: "Baixar modelo csv",
  ImportTable: "Importar tabela",
  ManageTable: "Gerenciar tabela",
  placeholder: "Arraste o título da coluna para agrupar as linhas",
  groupedBy: "Agrupar por:",
  ConsultProcessType: "Consultar tipo de processo",
  DayDays: "Dia(s)",
  ManagementReports: "Relatórios gerenciais classificação e temporalidade",
  ReportType: "Tipo de relatório",
  SelectReportType: "Selecione o tipo de relatório",
  ClassifiedDocuments: "Documentos classificados",
  CompleteRankingPlan: "Plano de classificação completo",
  PartialRankingPlan: "Plano de classificação parcial",
  SelectCodeClass: "Selecione o código | assunto da classe",
  RecordQuantities: "Quantidades de registro por pesquisa",
  SelectEnterGroup: "Selecione ou informe o grupo",
  SelectEnterSubgroup: "Selecione ou informe o subgrupo",
  QuickSearch: "Busca rápida",
  ImportStatus: "Status da importação",
  ImportDivergencesIdentified:
    "Segue(m) abaixo, divergência(s) identificada(s) no arquivo {format} importado.",
  StartDateFrom: "Data início (De)",
  StartDateTo: "Data início (Até)",
  NoCategory: "Sem categoria",
  DeleteProcessDefinitionInternalError:
    "Ocorreu um erro interno ao tentar deletar o processo",
  DisableProcessDefinitionInternalError:
    "Ocorreu um erro interno ao tentar desativar o processo",
  ActivateProcessDefinitionInternalError:
    "Ocorreu um erro interno ao tentar ativar o processo",
  ActivateProcessDefinitionSuccessfully: "Projeto ativado com sucesso!",
  DisableProcessDefinitionSuccessfully: "Projeto desabilitado com sucesso!",
  DeleteProcessDefinitionSuccessfully: "Projeto deletado com sucesso!",
  ToggleEnableProcessDefinitionText: "Deseja realmente :type o processo :name?",
  ReallyDeleteProcessDefinition: "Deseja realmente excluír o processo :name?",
  ActivateProcessDefinition: "Ativar processo",
  DisableProcessDefinition: "Desativar processo",
  ExclusionFromProcessDefinition: "Exclusão de processo",
  Complete: "Completo",
  Suspended: "Suspenso",
  FileInvalidType:
    "Formato de arquivo inválido; formato(s) válido(s) são {formats}",
  onDeadline: "No prazo",
  openDrafts: "Abrir rascunhos",
  draftDeleted: "Rascunho excluído",
  errorDraftDelete: "Erro inesperado ao excluir rascunho",
  processKey: "Chave do processo",
  saveDraft: "Salvar rascunho",
  saveDrafQuestion: "Deseja realmente salvar o rascunho?",
  draftSaved: "Rascunho salvo",
  draftUpdated: "Rascunho atualizado",
  errorDraftSave: "Erro inesperado ao salvar rascunho",
  errorDraftUpdate: "Erro inesperado ao atualizar rascunho",
  deleteDraft: "Excluir rascunho",
  deleteDrafQuestion: "Deseja realmente excluir o rascunho?",
  errorLoadingDraftXml: "Erro inesperado ao carregar rascunho",
  errorCreateOrganization: "Erro inesperado ao criar organização",
  successCreateOrganization: "Organização criada com sucesso",
  successUpdateOrganization: "Organização atualizada com sucesso",
  editOrganization: "Editar organização",
  enableOrganizationError: "Erro inesperado ao ativar organização",
  disableOrganizationError: "Erro inesperado ao desativar organização",
  listOrganizationError: "Erro inesperado ao lista organizações",
  tenants: "Tenants",
  additionalUsers: "Usuários adicionais",
  errorCreateTenant: "Erro inesperado ao criar tenant",
  editTenant: "Editar tenant",
  administrators: "Administradores",
  tenantHasEnabled: "Tenant ativado",
  tenantHasDisabled: "Tenant desativado",
  enableTenantError: "Erro inesperado ao ativar tenant",
  disableTenantError: "Erro inesperado ao desativar tenant",
  listTenantError: "Erro inesperado ao lista tenants",
  getOrganizationError: "Erro inesperado ao buscar organização",
  getTenantError: "Erro inesperado ao buscar tenant",
  newFile: "Novo arquivo",
  selectTemplate: "Selecionar template",
  errorListTemplates: "Erro inesperado ao listar templates",
  renderingError: "Erro ao renderizar componente",
  unknownError: "Erro desconhecido",
  organization: "Organização",
  createOrganization: "Cadastrar organização",
  fileSizeError: "Por favor, inclua apenas arquivos com até 4 MB.",
  fileTypeError:
    "Por favor, inclua apenas arquivos de imagens como PNG, JPG ou GIF",
  deleteForm: "Excluir Formulário?",
  savedForm: "Formulário salvo",
  tooltipSelectVariableName:
    "Id da variavel do processo que contém a lista dos valores",
  variableName: "Nome Variavel",
  tooltipJsonFieldValue: "Nome do campo no JSON que será usado como valor",
  jsonFieldValue: "Campo com o ID",
  tooltipJsonFieldText: "Nome do campo no JSON que será usado como Label",
  jsonFieldText: "Campo com o Label",
  processVariable: "Variável do processo",
  disableModelerFieldToolTip:
    "O campo ficará desabilitado enquanto as variáveis informadas não possuirem valor",
  waitVariableToBeFilled: "Aguardar o preenchimento de variáveis?",
  addVariable: "Adicionar variável",
  variableID: "ID da variável",
  loadingNextTask: "Carregando próxima tarefa...",
  noAvailableTask: "No momento não há tarefas disponíveis nesse processo.",
  redirectTaskList: "Voce será redirecionado para a lista de tarefas.",
  previewUnavailable: "Visualização indisponível no momento",
  documentSigning: "Assinatura de Documento",
  documentsToSign: "Documentos para assinar",
  folderName: "Nome da pasta",
  documentsToView: "Documentos para visualizar",
  selectDocuments: "Selecionar documentos",
  required: "Obrigatório",
  documentsInThisProcess: "Documentos nesse processo",
  hours: "Horas",
  hour: "Hora",
  minutes: "Minutos",
  minute: "Minuto",
  navigateTreeAndSelect:
    "Navegue pela árvore de pastas e selecione o local onde quer arquivar.",
  startByRepository: "Comece pelo repositório.",
  createFolderOnSelectedLevel:
    "Para criar pastas no nível selecionado, complete o caminho seguindo o padrão",
  pathUntilFolder: "Caminho até a pasta onde arquivará o(s) documento(s)",
  documentIsRequired: "Documentos para registrar é obrigatório.",
  documentTypeIsRequired: "Tipo de documento é obrigatório.",
  documentTitleIsRequired: "Título é obrigatório.",
  documentIdIsRequired: "Id é obrigatório.",
  storagePathIsRequired: "Local de armazenamento é obrigatório.",
  orderInTheSet: "Ordem no conjunto",
  templateIsRequired: "Template é obrigatório.",
  authorizedGroups: "Grupo(s) de Acesso Autorizado(s)",
  usersWithAccess: "Usuário(s) com acesso",
  manageAccess: "Gerenciar acessos",
  readTerms: "LER OS TERMOS",
  readLater: "LER DEPOIS",
  termsOfUse: "Termo de Uso",
  smartdocsTermsUpdated: "Os Termos de Uso do Smartdocs foram atualizados.",
  acceptTerms: "ACEITO OS TERMOS",
  dontAcceptTerms: "NÃO ACEITO OS TERMOS",
  needAcceptTerms: "É preciso aceitar os Termos de Uso para concluir o acesso.",
  cancelLogin: "CANCELAR LOGIN",
  termAccepted: "O Termo de Uso foi aceito com sucesso!",
  processVariableContainingTheDraft: "Variavel do processo contendo a minuta",
  selectTempalteType: "Selecione o tipo de template",
  selectTheDraft: "Selecione a minuta",
  templateTypeIsRequired: "Tipo de Template é Obrigatório",
  draftIsRequired: "Minuta é obrigatório",
  storageLocationInDocz: "Local de armazenamento no Docz",
  client: "Cliente",
  project: "Projeto",
  documentsToSend: "Documentos para envio",
  documentsToUpload: "Documentos para enviar",
  metadataForIntegration: "Metadados para a integração",
  sourceSmartdocs: "Origem - Smartdocs",
  destinationDocz: "Destino - Docz",
  groupIfFound: "Agrupar se encontrar",
  addRemove: "Adicionar/ Remover",
  noMetadataSelected: "Nenhum metadado selecionado",
  destinationProjectRequired: '"Projeto de destino" é obrigatório.',
  projectRepositoryRequired: '"Repositório do projeto" é obrigatório.',
  selectAtLeastOneDocumentToSend:
    'Selecione pelo menos UM "Documento para envio".',
  selectAtLeastOneMetadataForIntegration:
    'Selecione pelo menos UM "Metadado para a integração".',
  fillOrRemoveEmptyMetadataRelationships:
    "Preencha ou remova os relacionamentos de metadados vazios.",
  subfolderInRepositoryRequired: '"Subpasta no repositório" é obrigatório.',
  loggingInPleaseWait: "Fazendo o login, por favor aguarde...",
  signatureInformation: "Informações da Assinatura",
  signatureTitle: "Titulo da Assinatura",
  signatureDescription: "Descrição da Assinatura",
  signatureResponsibleName: "Nome do responśavel pela assinatura",
  signatureResponsibleEmail:
    "Email do responśavel pela assinatura de Assinatura",
  signatureResponsibleCpf: "CPF do responśavel pela assinatura",
  signatureDocumentToBeSigned: "Documento que será assinado",
  signers: "Assinantes",
  signerName: "Nome do Assinante",
  signerEmail: "Email do Assinante",
  signerCpf: "CPF do Assinante",
  signatureTitleRequired: "Titulo da Assinatura é obrigatório",
  signatureDescriptionRequired: "Descrição da Assinatura é obrigatório",
  signatureResponsibleNameRequired:
    "Nome do responśavel pela assinatura é obrigatório",
  signatureResponsibleEmailRequired:
    "Email do responśavel pela assinatura de Assinatura é obrigatório",
  signatureResponsibleCpfRequired:
    "CPF do responśavel pela assinatura é obrigatório",
  signatureDocumentToBeSignedRequired:
    "Documento que será assinado é obrigatório",
  signersRequired: "Assinantes é obrigatório",
  signerNameRequired: "Nome do Assinante é obrigatório",
  signerEmailRequired: "Email do Assinante é obrigatório",
  signerCpfRequired: "CPF do Assinante é obrigatório",
  fillOrRemoveEmptySigners: "Preencha ou remova os assinantes vazios",
  documentsForSigning: "Documentos para assinatura",
  noSignerSelected: "Nenhum assinante selecionado",
  loggingOutPleaseWait: "Deslogando, por favor aguarde...",
  loginWithSingleSignOn: "Entrar com login único",
  apiSelection: "Selecione a Api",
  apiInputParameters: "Parâmetros de Entrada da Api",
  apiVariable: "Variável da Api",
  noVariableSelected: "Nenhuma variável selecionada",
  apiOutputParameters: "Parâmetros de Saída da Api",
  apiResult: "Resultado da Api",
  noResultSelected: "Nenhum resultado selecionado",
  configureApi: "Configurar Api",
  url: "Url",
  httpMethod: "Método HTTP",
  headers: "Cabeçalhos",
  noHeaderSelected: "Nenhum cabeçalho selecionado",
  headerName: "Nome do cabeçalho",
  headerValue: "Valor do cabeçalho",
  urlParameters: "Parâmetros de Url",
  noUrlParameterSelected: "Nenhum parâmetro de url selecionado",
  parameterName: "Nome do parâmetro",
  parameterValue: "Valor do parâmetro",
  body: "Corpo",
  apiRequired: "Api é obrigatório",
  urlRequired: "Url é obrigatória",
  httpMethodRequired: "Método HTTP é obrigatório",
  ConfigureAutomaticProcessesOptionMenuFolder:
    "Configurar processos automáticos",
  ConfigureAutomaticProcessesTitle: "Processos automáticos",
  ConfigureAutomaticProcessesSubTitle:
    "Selecione o processo que deseja iniciar e o tipo que dará início",
  EnableAutomaticProcesses: "Ativar/Desativar",
  cancelLabelAutomaticProcesses: "Cancelar",
  saveLabelAutomaticProcesses: "Salvar",
  typesDocumentsForStart: "Tipos de documentos para iniciar",
  chooseAList: "Escolha uma Lista",
  chooseAColumnFromTheList: "Escolha uma coluna da lista",
  multDocsUpload: "Multiple Docs Upload",
  generatePublicLink: "Gerar link público",
  publicUrlLink: "Url link público",
  linkCopied: "Link copiado!",
  publicStartLink: "Link público do início",
  requestCreated: "Solicitação criada com sucesso!",
  receiveEmailSoon:
    "Nossa equipe já está trabalhando. Em breve você receberá novidades em seu e-mail.",
  keepYourRequestNumber: "Guarde o número da sua solicitação",
  request: "Solicitação",
  for: "de",
  updatesWillBeSent:
    "As atualizações serão enviadas para o e-mail cadastrado no seu perfil na ",
  stayAlert: ". Fique atento(a) para não perder prazos importantes.",
  resultType: "Tipo de resultado",
  noFormDataSelected: "Nenhum campo do form-data selecionado",
  fieldName: "Nome do campo",
  fieldValue: "Valor do campo",
  fieldType: "Tipo do campo",
  isADate: "É uma data ?",
  etiquetaVariable: "Variável onde será armazenada a Etiqueta",
  etiquetaVariablePrefix:
    'Variável deve começar com "dz_etiqueta" para que possa ser utilizada como metadado no "Registrar e Arquivar"',
  etiquetaVariableRequired: "Variável com a Etiqueta é obrigatória",
  codeType: "Tipo de código",
  model: "Modelo",
  idVariable: "Id/ Variável",
  codeContent: "Conteúdo do código",
  codeToGenerate: "Código(s) para gerar",
  noCodeSelected: "Nenhum código selecionado",
  publicFormNextButtonLabel: 'Texto do botão "Avançar"',
  publicFormDoneButtonLabel: 'Texto do botão "Concluir"',
  publicFormBackButtonLabel: 'Texto do botão "Voltar"',
  doczModalMultiDocsCheckBoxToolTip:
    "Ative esta opção se em alguma etapa do processo houve arquivamento e registro de documentos provenientes de um upload múltiplo. Assim, todos os arquivos registrados e arquivados provenientes deum upload múltiplo serão enviados automaticamente.",
  doczModalMultiDocsCheckBox:
    "Enviar arquivos multiplos que passaram por registrar e arquivar",
  multiDocsDoczModalToolTip:
    "Caso não houve registro e arquivamento de um campo de upload de documentos multiplos, você pode indicar o id do campo aqui, dessa forma todos os arquivos recuperados pelo componente de documentos multiplos serão enviados.",
  selectFormFieldId: "Selecione o campo do formulário",
  multiDocsField: "Id do campo de upload de multiplos documentos",
  selectFormFieldId: "Selecione o campo do formulário",
  fillOrRemoveEmptyFileMetadataRelationships:
    "Preencha ou remova os relacionamentos de metadados de arquivo vazios.",
  metadataForRegisteringDC: "Metadados para Registar/Agrupar DC",
  metadataForIndexingFile:
    "Metadados para indexar Documento(s)/Arquivos Digitais",
  digitalDocumentsFiles: "Documento(s)/Arquivos Digitais",
  fullName: "Nome completo",
  modelerEnvelopeForSignature:
    "Envelope de documento(s) para coleta de assinatura(s)",
  modelerNameEnvelope: "Dê um nome ao envelope",
  modelerDocumentsForSignature: "Documento(s) para assinatura",
  modelerSelectProcessDocuments: "Selecionar documento(s) do processo",
  modelerEnvelopeSender: "Remetente do envelope",
  modelerSenderIsSigner: "Remetente é assinante do(s) documento(s)",
  modelerSigner: "Assinante",
  modelerSignatureType: "Tipo de assinatura",
  modelerSignatureResult: "Resultado da assinatura",
  modelerSourceSignature: "Origem - Assinatura",
  modelerDestinationSmartdocs: "Destino - Smartdocs",
  modelerTooltipSourceVariableUsedOnSignature:
    "Variavel utilizada na assinatura",
  modelerTooltipDestinationVariableWhereFileWillBeStored:
    "Variavel onde o arquivo assinado será armazenado",
  modelerSignerResultInfo:
    "Caso não configure o resultado da assinatura, os arquivos originais do processo serão trocados pelos arquivos assinados. (Somente os arquivos utilizados na assinatura)",
  allowDownloadZip: "Permitir download de documentos em ZIP",
};
